// 媒体版位枚举
export const videoSelectListOptions = [
  { label: "腾讯看点", value: "SITE_SET_KANDIAN" },
  { label: "QQ、腾讯音乐及游戏", value: "SITE_SET_QQ_MUSIC_GAME" },
  { label: "腾讯新闻", value: "SITE_SET_TENCENT_NEWS" },
  { label: "腾讯视频", value: "SITE_SET_TENCENT_VIDEO" },
  { label: "优量汇", value: "SITE_SET_MOBILE_UNION" },
  { label: "微信公众号与小程序", value: "SITE_SET_WECHAT" },
];
// 自定义展示场景枚举
export const spreadSelectList = [
  { label: "Banner", value: "DISPLAY_SCENE_BANNER" },
  { label: "插屏", value: "DISPLAY_SCENE_INLINE" },
  { label: "开屏", value: "DISPLAY_SCENE_SPLASH" },
  { label: "原生", value: "DISPLAY_SCENE_NATIVE" },
  { label: "激励视频", value: "DISPLAY_SCENE_REWARDED_VIDEO" },
];
// 版位游戏场景枚举
export const gameSelectListOptions = [
  { label: "微信小游戏", value: "SITE_SET_MINI_GAME_WECHAT" },
  { label: "QQ小游戏", value: "SITE_SET_MINI_GAME_QQ" },
  { label: "App小游戏", value: "SITE_SET_MOBILE_GAME" },
];
// 按钮文案下拉内容
export const buttonTextList = [
  "了解更多",
  "立即下载",
  "立即领取",
  "立即试玩",
  "立即体验",
  "立即抢购",
  "立即开通",
  "立即秒杀",
  "下载应用",
  "下载游戏",
  "立即安装",
  "立即预约",
];
export const transferActionList = [
  { label: "关注", value: "OPTIMIZATIONGOAL_FOLLOW" },
  { label: "点击", value: "OPTIMIZATIONGOAL_CLICK" },
  { label: "下载", value: "OPTIMIZATIONGOAL_APP_DOWNLOAD" },
  { label: "App激活", value: "OPTIMIZATIONGOAL_APP_ACTIVATE" },
  { label: "App注册", value: "OPTIMIZATIONGOAL_APP_REGISTER" },
  { label: "次日留存", value: "OPTIMIZATIONGOAL_ONE_DAY_RETENTION" },
  { label: "App付费次数", value: "OPTIMIZATIONGOAL_APP_PURCHASE" },
  { label: "下单", value: "OPTIMIZATIONGOAL_ECOMMERCE_ORDER" },
  { label: "加入购物车", value: "OPTIMIZATIONGOAL_ECOMMERCE_CART" },
  { label: "商品详情页浏览", value: "OPTIMIZATIONGOAL_VIEW_COMMODITY_PAGE" },
  { label: "在线咨询", value: "OPTIMIZATIONGOAL_ONLINE_CONSULTATION" },
  { label: "电话拨打", value: "OPTIMIZATIONGOAL_TELEPHONE_CONSULTATION" },
  { label: "表单预约", value: "OPTIMIZATIONGOAL_PAGE_RESERVATION" },
  { label: "发货", value: "OPTIMIZATIONGOAL_DELIVERY" },
  { label: "有效在线咨询", value: "OPTIMIZATIONGOAL_PAGE_EFFECTIVE_ONLINE_CONSULT" },
  { label: "有效电话拨打", value: "OPTIMIZATIONGOAL_PAGE_EFFECTIVE_PHONE_CALL" },
  { label: "综合线索收集", value: "OPTIMIZATIONGOAL_LEADS_COLLECT" },
  { label: "首次付费", value: "OPTIMIZATIONGOAL_FIRST_PURCHASE" },
  { label: "进件", value: "OPTIMIZATIONGOAL_APPLY" },
  { label: "预授信", value: "OPTIMIZATIONGOAL_PRE_CREDIT" },
  { label: "授信", value: "OPTIMIZATIONGOAL_CREDIT" },
  { label: "提现", value: "OPTIMIZATIONGOAL_WITHDRAW_DEPOSITS" },
  { label: "关键页面访问", value: "OPTIMIZATIONGOAL_PROMOTION_VIEW_KEY_PAGE" },
  { label: "小游戏创角", value: "OPTIMIZATIONGOAL_MOBILE_APP_CREATE_ROLE" },
  { label: "跳转按钮点击", value: "OPTIMIZATIONGOAL_CANVAS_CLICK" },
  { label: "领券", value: "OPTIMIZATIONGOAL_PROMOTION_CLAIM_OFFER" },
  { label: "商品收藏", value: "OPTIMIZATIONGOAL_ECOMMERCE_ADD_TO_WISHLIST" },
  { label: "有效表单预约", value: "OPTIMIZATIONGOAL_CONFIRM_EFFECTIVE_LEADS_RESERVATION" },
  { label: "签收", value: "OPTIMIZATIONGOAL_PAGE_RECEIPT" },
  { label: "加企业微信客服", value: "OPTIMIZATIONGOAL_PAGE_SCAN_CODE" },
  { label: "选课", value: "OPTIMIZATIONGOAL_SELECT_COURSE" },
  { label: "电话潜在客户", value: "OPTIMIZATIONGOAL_CONFIRM_POTENTIAL_CUSTOMER_PHONE" },
  { label: "广告变现", value: "OPTIMIZATIONGOAL_MOBILE_APP_AD_INCOME" },
  { label: "小游戏授权", value: "OPTIMIZATIONGOAL_MOBILE_APP_ACCREDIT" },
  { label: "首次会员购买", value: "OPTIMIZATIONGOAL_PURCHASE_MEMBER_CARD" },
];

export const optimalObjectList = [
  { label: "激活", value: "APP_ACTIVATE" },
  { label: "App付费次数", value: "APP_PURCHASE" },
  { label: "App注册", value: "APP_REGISTER" },
  { label: "跳转按钮点击", value: "CANVAS_CLICK" },
  { label: "加入购物车", value: "ECOMMERCE_CART" },
  { label: "下单", value: "ECOMMERCE_ORDER" },
  { label: "首次付费", value: "FIRST_PURCHASE" },
  { label: "表单预约", value: "PAGE_RESERVATION" },
  { label: "关键页面浏览", value: "PROMOTION_VIEW_KEY_PAGE" },
  { label: "商品详情页浏览", value: "VIEW_COMMODITY_PAGE" },
];

//深度优化目标下拉框
export const deepOptimalObjectList = [
  { label: "App付费次数", value: "APP_PURCHASE" },
  { label: "App注册", value: "APP_REGISTER" },
  { label: "下单", value: "ECOMMERCE_ORDER" },
  { label: "首次付费", value: "FIRST_PURCHASE" },
  { label: "次日留存", value: "ONE_DAY_RETENTION" },
];

export const dayTimeList = [
  { label: "00:00", value: "00:00:00" },
  { label: "01:00", value: "01:00:00" },
  { label: "02:00", value: "02:00:00" },
  { label: "03:00", value: "03:00:00" },
  { label: "04:00", value: "04:00:00" },
  { label: "05:00", value: "05:00:00" },
  { label: "06:00", value: "06:00:00" },
  { label: "07:00", value: "07:00:00" },
  { label: "08:00", value: "08:00:00" },
  { label: "09:00", value: "09:00:00" },
  { label: "10:00", value: "10:00:00" },
  { label: "11:00", value: "11:00:00" },
  { label: "12:00", value: "12:00:00" },
  { label: "13:00", value: "13:00:00" },
  { label: "14:00", value: "14:00:00" },
  { label: "15:00", value: "15:00:00" },
  { label: "16:00", value: "16:00:00" },
  { label: "17:00", value: "17:00:00" },
  { label: "18:00", value: "18:00:00" },
  { label: "19:00", value: "19:00:00" },
  { label: "20:00", value: "20:00:00" },
  { label: "21:00", value: "21:00:00" },
  { label: "22:00", value: "22:00:00" },
  { label: "23:00", value: "23:00:00" },
  { label: "24:00", value: "24:00:00" },
];

export const ageList = [
  { value: "AGE_BETWEEN_14_18", label: "14-18", min: 14, max: 18 },
  { value: "AGE_BETWEEN_19_24", label: "19-24", min: 19, max: 24 },
  { value: "AGE_BETWEEN_25_29", label: "25-29", min: 25, max: 29 },
  { value: "AGE_BETWEEN_30_39", label: "30-39", min: 30, max: 39 },
  { value: "AGE_BETWEEN_40_49", label: "40-49", min: 40, max: 49 },
  { value: "AGE_ABOVE_50", label: "50+", min: 50, max: 66 },
];

export const combineImageTypeList = [
  { key: "COMBINE_3", value: 641, label: "常规多图1:1三图", num: 3 },
  { key: "COMBINE_4", value: 642, label: "常规多图1:1四图", num: 4 },
  { key: "COMBINE_6", value: 643, label: "常规多图1:1六图", num: 6 },
  { key: "CREATIVE_IMAGE_MODE_VIDEO", value: 1708, label: "卡片视频" },
  { key: "CREATIVE_IMAGE_MODE_LARGE", value: 1707, label: "卡片大图" },
  { key: "CREATIVE_IMAGE_MODE_LARGE_VERTICAL", value: 311, label: "常规大图" },
];

export function getAgeList(min, max) {
  let list = [];
  for (let index = min; index < max + 1; index++) {
    if (index !== 66) {
      list.push({ label: index, value: index });
    } else {
      list.push({ label: index + "+", value: index });
    }
  }
  return list;
}

// 校验money
export const validateMoney = (rule, value, callback) => {
  if (!value) {
    callback(new Error("不能为空"));
  } else if (!/^(?:[1-9]\d*|0)(?:\.\d{1,2})?$/.test(value)) {
    callback(new Error("请输入至多保留2位小数的正数！"));
  } else {
    callback();
  }
};

// 日期框配置
export const pickerOptions = {
  disabledDate(time) {
    return time.getTime() < Date.now() - 3600 * 1000 * 24;
  },
  shortcuts: [
    {
      text: "今天",
      onClick(picker) {
        picker.$emit("pick", new Date());
      },
    },
    {
      text: "明天",
      onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24);
        picker.$emit("pick", date);
      },
    },
    {
      text: "7天后",
      onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
        picker.$emit("pick", date);
      },
    },
    {
      text: "30天后",
      onClick(picker) {
        const date = new Date();
        date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
        picker.$emit("pick", date);
      },
    },
  ],
};

// 获取全时段投放数据格式，即全部1
export const getAllTimeSeries = () => {
  let str = "1";
  for (let i = 0; i < 48 * 7 - 1; i++) {
    str += "1";
  }
  return str;
};

// 将版位的value值转换成label
export const transferSiteKeyToLabel = (key) => {
  const options = videoSelectListOptions.concat(gameSelectListOptions);
  const obj = options.find((item) => item.value === key) || {};
  return obj.label;
};

export const iosVersionList = [
  { value: "IOS_VERSION_4", label: "IOS 4.x" },
  { value: "IOS_VERSION_5", label: "IOS 5.x" },
  { value: "IOS_VERSION_6", label: "IOS 6.x" },
  { value: "IOS_VERSION_7", label: "IOS 7.x" },
  { value: "IOS_VERSION_8", label: "IOS 8.x" },
  { value: "IOS_VERSION_9", label: "IOS 9.x" },
  { value: "IOS_VERSION_10", label: "IOS 10.x" },
  { value: "IOS_VERSION_11", label: "IOS 11.x" },
  { value: "IOS_VERSION_12", label: "IOS 12.x" },
  { value: "IOS_VERSION_13", label: "IOS 13.x" },
  { value: "IOS_VERSION_14", label: "IOS 14.x" },
  { value: "IOS_VERSION_15", label: "IOS 15.x" },
];

export const androidVersionList = [
  { value: "ANDROID_VERSION_2", label: "Android 2.x" },
  { value: "ANDROID_VERSION_3", label: "Android 3.x" },
  { value: "ANDROID_VERSION_4", label: "Android 4.x" },
  { value: "ANDROID_VERSION_5", label: "Android 5.x" },
  { value: "ANDROID_VERSION_6", label: "Android 6.x" },
  { value: "ANDROID_VERSION_7", label: "Android 7.x" },
  { value: "ANDROID_VERSION_8", label: "Android 8.x" },
  { value: "ANDROID_VERSION_9", label: "Android 9.x" },
  { value: "ANDROID_VERSION_10", label: "Android 10.x" },
  { value: "ANDROID_VERSION_11", label: "Android 11.x" },
];

export const wordTypeOptions = [
  {
    id: "9",
    industryId: "21474836482",
    industryName: "招商加盟服务",
    level: "1",
    parentIndustryId: "0",
    description:
      "招商加盟指一种商业行为：品牌方通过获得加盟费，加盟商获得以某一品牌的连锁形式进行商业运营的经营资质，此处指招商加盟行为中提供品牌和服务的商事主体",
    children: [
      {
        id: "10",
        industryId: "21474836683",
        industryName: "教育培训加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各类教育培训机构招商加盟服务的商事主体",
      },
      {
        id: "11",
        industryId: "21474836684",
        industryName: "成人用品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖 成人性生活的招商加盟服务商事主体",
      },
      {
        id: "12",
        industryId: "21474836685",
        industryName: "医疗招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "涉及保健、健康、健脑、医疗相关用品或机构招商加盟",
      },
      {
        id: "13",
        industryId: "21474836686",
        industryName: "汽车用品及服务招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造、经销售卖与服务 汽车用品的招商加盟服务商事主体",
      },
      {
        id: "14",
        industryId: "21474836687",
        industryName: "招商加盟综合平台",
        level: "2",
        parentIndustryId: "21474836482",
        description: "包含3种及以上的综合型第三方加盟平台的运营商事主体",
      },
      {
        id: "15",
        industryId: "21474836688",
        industryName: "其他生活服务招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供其他未列举的生活服务招商加盟服务的商事主体",
      },
      {
        id: "16",
        industryId: "21474836689",
        industryName: "农林牧渔招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各种农林牧渔招商加盟服务的商事主体",
      },
      {
        id: "17",
        industryId: "21474836690",
        industryName: "服饰鞋帽箱包招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖 服饰鞋帽箱包的招商加盟服务商事主体",
      },
      {
        id: "18",
        industryId: "21474836691",
        industryName: "休闲娱乐招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指娱乐休闲场所类招商加盟服务",
      },
      {
        id: "19",
        industryId: "21474836692",
        industryName: "房地产招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各类房产地售卖和中介活动的招商加盟服务的商事主体",
      },
      {
        id: "20",
        industryId: "21474836693",
        industryName: "工业工程招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供关于各类工业设备租赁与销售招商加盟服务的商事主体",
      },
      {
        id: "21",
        industryId: "21474836694",
        industryName: "互联网电商服务招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供互联网电商服务招商加盟服务的商事主体",
      },
      {
        id: "22",
        industryId: "21474836695",
        industryName: "家装家具招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造、经销售卖与服务 家居建材产品的招商加盟服务商事主体",
      },
      {
        id: "23",
        industryId: "21474836696",
        industryName: "节能环保招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "提供环境监测、污染治理、废旧回收等服务的招商加盟服务商事主体",
      },
      {
        id: "24",
        industryId: "21474836697",
        industryName: "酒店与旅游招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供旅游业各个环节与业务内容的招商加盟服务的商事主体",
      },
      {
        id: "25",
        industryId: "21474836698",
        industryName: "酒水招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖含酒精饮品的招商加盟服务商事主体",
      },
      {
        id: "26",
        industryId: "21474836699",
        industryName: "零售百货招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各类零售百货门店的招商加盟服务的商事主体",
      },
      {
        id: "27",
        industryId: "21474836700",
        industryName: "亲子用品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖 亲子场景中的物品的招商加盟服务商事主体",
      },
      {
        id: "28",
        industryId: "21474836701",
        industryName: "日用百货招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖 生活休闲日用品的招商加盟服务商事主体",
      },
      {
        id: "29",
        industryId: "21474836702",
        industryName: "软件工具招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各类软件工具招商加盟服务的商事主体（如有游戏也包含）",
      },
      {
        id: "30",
        industryId: "21474836703",
        industryName: "商务服务业招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "提供商务服务（法律、会展服务等）的招商加盟服务商事主体",
      },
      {
        id: "31",
        industryId: "21474836704",
        industryName: "食品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖食品、饮料、零食的招商加盟服务商事主体",
      },
      {
        id: "32",
        industryId: "21474836705",
        industryName: "数码家电招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖数码家电的招商加盟服务商事主体",
      },
      {
        id: "33",
        industryId: "21474836706",
        industryName: "特殊用途化妆品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖特殊用途化妆品的招商加盟服务商事主体",
      },
      {
        id: "34",
        industryId: "21474836707",
        industryName: "一般用途化妆品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖一般用途化妆品的招商加盟服务商事主体",
      },
      {
        id: "35",
        industryId: "21474836708",
        industryName: "运动户外用品招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "制造与经销售卖 运动户外场景中的物品的招商加盟服务商事主体",
      },
      {
        id: "36",
        industryId: "21474836709",
        industryName: "珠宝招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供珠宝的制造环节与经销售卖环节的招商加盟服务的商事主体",
      },
      {
        id: "37",
        industryId: "21474836710",
        industryName: "餐饮招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供各类餐饮服务招商加盟服务的商事主体",
      },
      {
        id: "38",
        industryId: "21474836711",
        industryName: "烘焙饮料招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供烘培饮料服务招商加盟服务的商事主体",
      },
      {
        id: "39",
        industryId: "21474836712",
        industryName: "减肥保健招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供涉及减肥相关用品招商加盟服务的商事主体",
      },
      {
        id: "40",
        industryId: "21474836713",
        industryName: "美容美发招商加盟",
        level: "2",
        parentIndustryId: "21474836482",
        description: "指提供美容和美发相关用品及服务门店招商加盟服务的商事主体",
      },
    ],
  },
  {
    id: "41",
    industryId: "21474836485",
    industryName: "教育",
    level: "1",
    parentIndustryId: "0",
    description:
      "包括 ：1）提供学历教育、教育辅助服务及技术支持的商事主体，2）专门从事和组织非学历技能（如语言、才艺）和职业技能的商事主体，3）提供体系化课程的线上聚合服务的商事主体",
    children: [
      {
        id: "42",
        industryId: "21474836984",
        industryName: "教育综合服务平台",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指提供课程的综合线上教育平台的商事主体",
      },
      {
        id: "43",
        industryId: "21474836987",
        industryName: "外语培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指针对外语学习者提供听、说、读、写等方面能力培训的商事主体",
      },
      {
        id: "44",
        industryId: "21474836990",
        industryName: "文化艺术培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指提供各类兴趣班，各类文化艺术培训的商事主体",
      },
      {
        id: "45",
        industryId: "21474836991",
        industryName: "教学辅助工具",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指提供运用于教学过程中的各类辅助用具（如：单词卡）的商事主体",
      },
      {
        id: "46",
        industryId: "21474836994",
        industryName: "学历教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "颁发国家及教育部认可的各级学历学位证书的院校，例：深圳中学",
      },
      {
        id: "47",
        industryId: "21474836995",
        industryName: "家庭教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指服务于家庭内部教育课程的商事主体，如家长课堂",
      },
      {
        id: "48",
        industryId: "21474836996",
        industryName: "教育厅局",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指教育行政管理单位，及直属行政管理单位的教育管理法人机构",
      },
      {
        id: "49",
        industryId: "21474836997",
        industryName: "科学创造教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "采用STEAM教育相关理念或方法的教育商事主体",
      },
      {
        id: "50",
        industryId: "21474836998",
        industryName: "老年兴趣",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指为老年人提供的艺术相关的各种教育的商事主体",
      },
      {
        id: "51",
        industryId: "21474836999",
        industryName: "企业管理培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指面向企业或职业人士，提供组织和企业管理课程的商事主体",
      },
      {
        id: "52",
        industryId: "21474837000",
        industryName: "特殊教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指为残障及其他特殊人士提供定向教育的商事主体",
      },
      {
        id: "53",
        industryId: "21474837001",
        industryName: "体育培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "各类体育运动培训商事主体",
      },
      {
        id: "54",
        industryId: "21474837002",
        industryName: "孕期教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "指在婴儿出生前，面向孕期家长提供辅导和教育的商事主体",
      },
      {
        id: "55",
        industryId: "21474837003",
        industryName: "学历教育-非学历机构",
        level: "2",
        parentIndustryId: "21474836485",
        description: "辅助服务学历提升的培训机构或咨询机构等商事主体",
      },
      {
        id: "56",
        industryId: "21474837004",
        industryName: "财商培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "为有意愿学习投资理财的人群提供课程的机构，如：微淼商学院",
      },
      {
        id: "57",
        industryId: "21474837005",
        industryName: "境外学校",
        level: "2",
        parentIndustryId: "21474836485",
        description: "地处中国大陆境外，拥有当地办学和文凭颁发资格的商事主体",
      },
      {
        id: "58",
        industryId: "21474837006",
        industryName: "留学准备与咨询",
        level: "2",
        parentIndustryId: "21474836485",
        description: "为有留学意愿的学生提供各种帮助服务的商事主体，例：金吉列留学",
      },
      {
        id: "59",
        industryId: "21474837007",
        industryName: "启蒙教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "面向3-8岁孩童提供学前教育的商事主体，含托管班",
      },
      {
        id: "60",
        industryId: "21474837008",
        industryName: "早期教育",
        level: "2",
        parentIndustryId: "21474836485",
        description: "面向0-3岁孩童的思维进行开发培养的教育商事主体",
      },
      {
        id: "61",
        industryId: "21474837009",
        industryName: "公务员考试培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "为有意愿参加公务员和事业编制考试的人士提供帮助服务的商事主体",
      },
      {
        id: "62",
        industryId: "21474837010",
        industryName: "职业技能培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "提供就业相关知识和技能（如UI设计）培训的商事主体",
      },
      {
        id: "63",
        industryId: "21474837011",
        industryName: "职业资格考证培训",
        level: "2",
        parentIndustryId: "21474836485",
        description: "提供国家职业资格及国际从业资格认证（如CFA）相关培训的机构",
      },
    ],
  },
  {
    id: "64",
    industryId: "21474836486",
    industryName: "金融",
    level: "1",
    parentIndustryId: "0",
    description:
      "是指经营和销售金融产品的商事主体，包括银行、保险、证券、期货市场和其他各类金融商事主体；也包括给用户提供投资理财咨询服务和线上金融平台及辅助工具的商事主体集合",
    children: [
      {
        id: "65",
        industryId: "21474837082",
        industryName: "基金",
        level: "2",
        parentIndustryId: "21474836486",
        description: "管理或发行基金的金融商事主体，如：博时基金",
      },
      {
        id: "66",
        industryId: "21474837087",
        industryName: "贵金属",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指提供贵金属购买与售卖等交易服务的金融商事主体",
      },
      {
        id: "67",
        industryId: "21474837088",
        industryName: "典当",
        level: "2",
        parentIndustryId: "21474836486",
        description: "具备典当经营许可证的典当行，例：华夏典当行",
      },
      {
        id: "68",
        industryId: "21474837089",
        industryName: "担保",
        level: "2",
        parentIndustryId: "21474836486",
        description: "涵盖融资担保和非融资担保机构，例：中投保、瀚华担保",
      },
      {
        id: "69",
        industryId: "21474837091",
        industryName: "投资咨询",
        level: "2",
        parentIndustryId: "21474836486",
        description: "为企业投资项目提供尽职调查、基本面研究等咨询服务的商事主体",
      },
      {
        id: "70",
        industryId: "21474837092",
        industryName: "信托",
        level: "2",
        parentIndustryId: "21474836486",
        description: "获银监会批准，以受托人身份承诺信托和处理信托事务的机构",
      },
      {
        id: "71",
        industryId: "21474837093",
        industryName: "资产管理",
        level: "2",
        parentIndustryId: "21474836486",
        description: "为投资者提供资产管理服务的金融服务机构，例，贝莱德、国厚资产",
      },
      {
        id: "72",
        industryId: "21474837094",
        industryName: "非货币标准金融",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指财务公司、货币经纪公司、贷款公司、金融租赁公司",
      },
      {
        id: "73",
        industryId: "21474837095",
        industryName: "大宗商品交易/现货",
        level: "2",
        parentIndustryId: "21474836486",
        description: "专业从事电子买卖交易套保的大宗类商品市场，例：找钢网",
      },
      {
        id: "74",
        industryId: "21474837096",
        industryName: "金融综合服务平台",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指提供各类金融服务（资讯、数据等）的线上平台（助贷平台除外）",
      },
      {
        id: "75",
        industryId: "21474837097",
        industryName: "银行信用卡中心",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指商业银行信用卡中心业、信用卡组织与商业银行发信用卡",
      },
      {
        id: "76",
        industryId: "21474837098",
        industryName: "第三方支付",
        level: "2",
        parentIndustryId: "21474836486",
        description: "具备业务许可，经营网络支付业务的非银行机构，例：微信支付",
      },
      {
        id: "77",
        industryId: "21474837100",
        industryName: "汽车金融",
        level: "2",
        parentIndustryId: "21474836486",
        description: "经银监会批准，为汽车购买及销售者提供金融服务的非银行金融机构",
      },
      {
        id: "78",
        industryId: "21474837101",
        industryName: "期货期权",
        level: "2",
        parentIndustryId: "21474836486",
        description: "提供期权与期货买卖服务的金融商事主体，如：中国金融期货交易所",
      },
      {
        id: "79",
        industryId: "21474837102",
        industryName: "外汇",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指提供外汇购买与售卖等交易服务的金融商事主体",
      },
      {
        id: "80",
        industryId: "21474837104",
        industryName: "商业保理",
        level: "2",
        parentIndustryId: "21474836486",
        description: "为企业提供保理服务的金融服务商事主体，例：中信保理",
      },
      {
        id: "81",
        industryId: "21474837105",
        industryName: "金融辅助工具",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指记账、利息计算、股票交易模拟等不包含交易业务本身的辅助工具",
      },
      {
        id: "82",
        industryId: "21474837107",
        industryName: "消费金融",
        level: "2",
        parentIndustryId: "21474836486",
        description: "不吸收公众存款，以小额、分散为原则提供消费金融服务的公司",
      },
      {
        id: "83",
        industryId: "21474837108",
        industryName: "众筹",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指通过各种方式向大众筹集资金的集资商事主体",
      },
      {
        id: "84",
        industryId: "21474837109",
        industryName: "保险",
        level: "2",
        parentIndustryId: "21474836486",
        description: "提供保险服务的商事主体，例：中国人寿、众安保险",
      },
      {
        id: "85",
        industryId: "21474837110",
        industryName: "保险代理服务",
        level: "2",
        parentIndustryId: "21474836486",
        description: "根据保险人的委托，在授权范围内代为办理保险业务的商事主体",
      },
      {
        id: "86",
        industryId: "21474837111",
        industryName: "保险经纪服务",
        level: "2",
        parentIndustryId: "21474836486",
        description: "基于投保人的利益，提供保险经纪服务的商事主体",
      },
      {
        id: "87",
        industryId: "21474837112",
        industryName: "地方小额贷款",
        level: "2",
        parentIndustryId: "21474836486",
        description: "经地方金融办或监管部门批准，不吸收公众存款，经营小额贷款公司",
      },
      {
        id: "88",
        industryId: "21474837113",
        industryName: "网络小额贷款",
        level: "2",
        parentIndustryId: "21474836486",
        description: "经省/直辖市金融办批准，利用互联网面向公众提供小额贷款的公司",
      },
      {
        id: "89",
        industryId: "21474837114",
        industryName: "助贷平台",
        level: "2",
        parentIndustryId: "21474836486",
        description: "通过与金融机构合作提供辅助放贷服务的商事主体，例：诺诺金服",
      },
      {
        id: "90",
        industryId: "21474837115",
        industryName: "银行",
        level: "2",
        parentIndustryId: "21474836486",
        description: "银行品牌及业务线，含：企业贷款，个人贷款，银行APP等服务",
      },
      {
        id: "91",
        industryId: "21474837116",
        industryName: "银行理财子公司",
        level: "2",
        parentIndustryId: "21474836486",
        description: "由商业银行设立，从事理财业务的非银行金融机构，例：信银理财",
      },
      {
        id: "92",
        industryId: "21474837117",
        industryName: "券商",
        level: "2",
        parentIndustryId: "21474836486",
        description: "指持有证监会证券经纪业务牌照，提供证券买卖经纪服务的金融机构",
      },
      {
        id: "93",
        industryId: "21474837118",
        industryName: "证券投资顾问",
        level: "2",
        parentIndustryId: "21474836486",
        description: "持有证监会证券投资顾问牌照，提供证券投顾咨询服务的金融机构",
      },
      {
        id: "94",
        industryId: "21474837119",
        industryName: "征信",
        level: "2",
        parentIndustryId: "21474836486",
        description: "对企业和个人的信用信息进行采集、整理、保存、加工等服务的机构",
      },
    ],
  },
  {
    id: "95",
    industryId: "21474836487",
    industryName: "旅游出行",
    level: "1",
    parentIndustryId: "0",
    description: "旅游出行指旅游业和出行相关的服务行业内的商事主体，包括围绕旅行游览活动和旅客运输所发展起来的服务，例如客运票务、酒店等",
    children: [
      {
        id: "96",
        industryId: "21474837184",
        industryName: "旅行社",
        level: "2",
        parentIndustryId: "21474836487",
        description: "为旅游者代办出入境和签证、接待、安排食宿的商事主体",
      },
      {
        id: "97",
        industryId: "21474837186",
        industryName: "OTA平台",
        level: "2",
        parentIndustryId: "21474836487",
        description: "运营旅行资讯攻略、线上综合旅行预订平台的商事主体。例：携程",
      },
      {
        id: "98",
        industryId: "21474837189",
        industryName: "境外景点",
        level: "2",
        parentIndustryId: "21474836487",
        description: "中国大陆境外景点景区运营者和相关票务服务的提供者。例：卢浮宫",
      },
      {
        id: "99",
        industryId: "21474837190",
        industryName: "旅游局-境内",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指中国内地各省、市、自治区旅游主管单位",
      },
      {
        id: "100",
        industryId: "21474837191",
        industryName: "旅游局-境外",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指中国大陆境外旅游局或官方旅游主管单位",
      },
      {
        id: "101",
        industryId: "21474837192",
        industryName: "航空旅客运输",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供客运为主的航空运输服务的商事主体（含售票服务）",
      },
      {
        id: "102",
        industryId: "21474837193",
        industryName: "游轮",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供娱乐航海的客轮商事主体，含交通、住宿、餐厅、娱乐元素",
      },
      {
        id: "103",
        industryId: "21474837194",
        industryName: "道路旅客运输",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指提供所有道路的旅客运输服务的商事主体以及包含自身的售票服务",
      },
      {
        id: "104",
        industryId: "21474837195",
        industryName: "境外租车服务",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指在中国大陆境外地点提供交通工具租赁（不配备驾驶人员）服务的商事主体",
      },
      {
        id: "105",
        industryId: "21474837196",
        industryName: "水上旅客运输",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供客运为主的水上运输服务的商事主体（含售票服务）",
      },
      {
        id: "106",
        industryId: "21474837197",
        industryName: "铁路旅客运输",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供城际间铁路旅客运输服务的商事主体（含地铁和售票服务）",
      },
      {
        id: "107",
        industryId: "21474837198",
        industryName: "乡村游及文旅小镇",
        level: "2",
        parentIndustryId: "21474836487",
        description: "围绕乡村或特色小镇的文化资源，发展旅游服务的商事主体",
      },
      {
        id: "108",
        industryId: "21474837199",
        industryName: "游学观光活动",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指提供主要针对于在校学生的游玩兼学习的观光活动服务的商事主体",
      },
      {
        id: "109",
        industryId: "21474837200",
        industryName: "出行资讯及票务预定平台",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供水陆空出行相关服务的线上综合平台（含购票、乘车码等）",
      },
      {
        id: "110",
        industryId: "21474837201",
        industryName: "动植物园",
        level: "2",
        parentIndustryId: "21474836487",
        description: "向公众开放的提供野生动植物展览的场所的运营者和票务服务提供者",
      },
      {
        id: "111",
        industryId: "21474837202",
        industryName: "度假区",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指多元素构成的旅游区的运营商事主体和相关票务服务提供者",
      },
      {
        id: "112",
        industryId: "21474837203",
        industryName: "景点景区",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指景点景区的运营者、相关票务服务提供者。例：八达岭长城",
      },
      {
        id: "113",
        industryId: "21474837204",
        industryName: "主题乐园",
        level: "2",
        parentIndustryId: "21474836487",
        description: "围绕主题，配合不同景观设施提供旅游服务者和相关票务服务提供者",
      },
      {
        id: "114",
        industryId: "21474837205",
        industryName: "酒店-境内",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指于中国大陆境内为旅客提供食宿的商业场所",
      },
      {
        id: "115",
        industryId: "21474837206",
        industryName: "酒店-境外",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指于中国大陆境外为旅客提供食宿的商业场所",
      },
      {
        id: "116",
        industryId: "21474837207",
        industryName: "露营地服务",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指提供露营设施（如帐篷等设备）和露营场地服务的商事主体",
      },
      {
        id: "117",
        industryId: "21474837208",
        industryName: "出行服务平台",
        level: "2",
        parentIndustryId: "21474836487",
        description: "提供城市汽车出行与共享单车服务的线上平台（不含汽车厂商自营）",
      },
      {
        id: "118",
        industryId: "21474837209",
        industryName: "境内租车服务",
        level: "2",
        parentIndustryId: "21474836487",
        description: "指在境内地点提供交通工具租赁（不配备驾驶人员）服务的商事主体",
      },
    ],
  },
  {
    id: "119",
    industryId: "21474836488",
    industryName: "护肤彩妆",
    level: "1",
    parentIndustryId: "0",
    description: "指生产与经销具有清洁、滋润、营养、保护和美化皮肤的化妆用品及工具的商事主体集合",
    children: [
      {
        id: "120",
        industryId: "21474837288",
        industryName: "一般化妆品",
        level: "2",
        parentIndustryId: "21474836488",
        description: "指制造与经销以清洁、保护、美化、修饰为目的化妆品的商事主体",
      },
      {
        id: "121",
        industryId: "21474837289",
        industryName: "特殊用途化妆品",
        level: "2",
        parentIndustryId: "21474836488",
        description: "制造与经销染发、烫发、防脱发、祛斑的化妆品的商事主体",
      },
      {
        id: "122",
        industryId: "21474837290",
        industryName: "美容工具",
        level: "2",
        parentIndustryId: "21474836488",
        description: "制造与经销 用于化妆和美容的日用非电工具的商事主体",
      },
    ],
  },
  {
    id: "123",
    industryId: "21474836496",
    industryName: "运动户外",
    level: "1",
    parentIndustryId: "0",
    description: "指各类生产与经销用于户外运动场景中的各类器具服饰的商事主体",
    children: [
      {
        id: "124",
        industryId: "21474838090",
        industryName: "户外装备",
        level: "2",
        parentIndustryId: "21474836496",
        description: "指制造与经销用于户外活动的各种工具与设备的商事主体",
      },
      {
        id: "125",
        industryId: "21474838092",
        industryName: "体育用品",
        level: "2",
        parentIndustryId: "21474836496",
        description: "指制造与经销运动用具和配件的商事主体，如：球具、骑行配件等",
      },
      {
        id: "126",
        industryId: "21474838094",
        industryName: "运动户外服饰鞋帽箱包",
        level: "2",
        parentIndustryId: "21474836496",
        description: "指制造与经销以户外运动功能为主的服饰鞋帽箱包的商事主体",
      },
      {
        id: "127",
        industryId: "21474838095",
        industryName: "健身器械",
        level: "2",
        parentIndustryId: "21474836496",
        description: "指制造与经销主要用于健身训练的非电器类器械的商事主体",
      },
      {
        id: "128",
        industryId: "21474838096",
        industryName: "健身电器",
        level: "2",
        parentIndustryId: "21474836496",
        description: "指制造与经销主要用于健身训练的电器类器械的商事主体",
      },
    ],
  },
  {
    id: "129",
    industryId: "21474836497",
    industryName: "珠宝钟表眼镜",
    level: "1",
    parentIndustryId: "0",
    description: "指生产与经销及修理钟表、眼镜、首饰、艺术品、矿物宝石等贵重制品的商事主体",
    children: [
      {
        id: "130",
        industryId: "21474838186",
        industryName: "珠宝首饰",
        level: "2",
        parentIndustryId: "21474836497",
        description: "制造加工与经销由贵重材料制成的高价值珠宝首饰的商事主体",
      },
      {
        id: "131",
        industryId: "21474838187",
        industryName: "钟表",
        level: "2",
        parentIndustryId: "21474836497",
        description: "制造与经销 以机械力、电力驱动的计量时间的精密仪器的商事主体",
      },
      {
        id: "132",
        industryId: "21474838188",
        industryName: "文玩和艺术品",
        level: "2",
        parentIndustryId: "21474836497",
        description: "制造加工与经销 有收藏价值的手工艺术品的商事主体，如紫砂壶",
      },
      {
        id: "133",
        industryId: "21474838189",
        industryName: "眼镜",
        level: "2",
        parentIndustryId: "21474836497",
        description: "制造与经销 矫正近远视、遮挡紫外线等功能眼镜的商事主体",
      },
    ],
  },
  {
    id: "134",
    industryId: "21474836501",
    industryName: "医疗健康",
    level: "1",
    parentIndustryId: "0",
    description:
      "医疗服务是指卫生技术人员遵照执业技术规范提供的照护生命、诊治疾病的健康促进服务，以及为实现这些服务提供的药品、医疗器械、救助运输、病房住宿等服务",
    children: [
      {
        id: "135",
        industryId: "21474838584",
        industryName: "美容减肥保健食品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产和销售具有特定、集中效果（美容与减肥）的保健食品",
      },
      {
        id: "136",
        industryId: "21474838586",
        industryName: "互联网诊疗平台",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指医疗机构注册医师通过互联网技术提供部分常见诊疗服务",
      },
      {
        id: "137",
        industryId: "21474838587",
        industryName: "健康资讯服务平台",
        level: "2",
        parentIndustryId: "21474836501",
        description: "提供健康资讯、医疗机构信息（含挂号）的互联网线上平台商事主体",
      },
      {
        id: "138",
        industryId: "21474838589",
        industryName: "精神卫生中心",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供心理健康咨询与治疗服务的医疗商事主体",
      },
      {
        id: "139",
        industryId: "21474838592",
        industryName: "药品资讯信息",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指提供药品资讯和信息发布、聚合、查询等服务的在线信息平台",
      },
      {
        id: "140",
        industryId: "21474838594",
        industryName: "医疗器械零售",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指售卖各种医疗用品与器械的线下零售门店",
      },
      {
        id: "141",
        industryId: "21474838595",
        industryName: "假肢生产装配",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产和经销用于克服、掩饰肢体伤残的各类器械的商事主体",
      },
      {
        id: "142",
        industryId: "21474838596",
        industryName: "美容整形医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指提供各种整形服务的医美商事主体",
      },
      {
        id: "143",
        industryId: "21474838597",
        industryName: "体检机构",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指提供各类体检项目的商事主体。例：爱康国宾",
      },
      {
        id: "144",
        industryId: "21474838598",
        industryName: "综合医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "提供综合医疗服务的医疗商事主体。例：北京协和医院",
      },
      {
        id: "145",
        industryId: "21474838600",
        industryName: "口腔医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供口腔诊疗服务的医疗商事主体",
      },
      {
        id: "146",
        industryId: "21474838601",
        industryName: "疗养院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "向老年人、慢性病患者等人士提供疗养、康复、护理服务的医疗机构",
      },
      {
        id: "147",
        industryId: "21474838602",
        industryName: "临床检验服务机构",
        level: "2",
        parentIndustryId: "21474836501",
        description: "针对人体健康状况诊断，对人体标本进行临床检验的商事主体",
      },
      {
        id: "148",
        industryId: "21474838603",
        industryName: "社区卫生服务中心",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指以社区为基本单位设立的医疗服务商事主体",
      },
      {
        id: "149",
        industryId: "21474838604",
        industryName: "特殊医学用途配方食品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指针对进食受限、消化吸收障碍的人群特定的食品营养素或特殊膳食",
      },
      {
        id: "150",
        industryId: "21474838605",
        industryName: "诊所",
        level: "2",
        parentIndustryId: "21474836501",
        description: "个体规模小的医疗服务商事主体，通常为门诊、药房，多属于私人",
      },
      {
        id: "151",
        industryId: "21474838606",
        industryName: "中医医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "主要提供传统医药诊疗的医疗商事主体。例：广东省中医院",
      },
      {
        id: "152",
        industryId: "21474838607",
        industryName: "保健用品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指制造与经销具有保健功效用品的商事主体（非医疗器械、非内服）",
      },
      {
        id: "153",
        industryId: "21474838608",
        industryName: "宠物医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供针对于宠物的医疗服务商事主体",
      },
      {
        id: "154",
        industryId: "21474838609",
        industryName: "宠物用药",
        level: "2",
        parentIndustryId: "21474836501",
        description: "宠物药品的生产与经销商，例：小宠",
      },
      {
        id: "155",
        industryId: "21474838610",
        industryName: "保健食品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产和销售具有国家保健品资质，宣传保健或营养补充功能的食品",
      },
      {
        id: "156",
        industryId: "21474838611",
        industryName: "保健食品用品零售",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指售卖各种保健食品及用品的卖场或门店",
      },
      {
        id: "157",
        industryId: "21474838612",
        industryName: "海外保健食品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产和直接销售来源地为海外的保健食品的商事主体",
      },
      {
        id: "158",
        industryId: "21474838613",
        industryName: "药店",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指售卖各种药品的线下零售门店",
      },
      {
        id: "159",
        industryId: "21474838614",
        industryName: "药品交易平台",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指提供各类药品交易的互联网线上平台",
      },
      {
        id: "160",
        industryId: "21474838615",
        industryName: "成人类药品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "性功能及生育相关药品的生产与经销商",
      },
      {
        id: "161",
        industryId: "21474838616",
        industryName: "药品",
        level: "2",
        parentIndustryId: "21474836501",
        description: "药品（包括中药、化学药和生物制品）的生产与经销商，例：辉瑞",
      },
      {
        id: "162",
        industryId: "21474838617",
        industryName: "成人医疗器械",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产和销售用于计划生育相关医疗器械的",
      },
      {
        id: "163",
        industryId: "21474838618",
        industryName: "医疗器械",
        level: "2",
        parentIndustryId: "21474836501",
        description: "生产与经销用于医疗诊断、监护和治疗工作的各类器械的商事主体",
      },
      {
        id: "164",
        industryId: "21474838619",
        industryName: "不孕不育医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供针对不孕不育等问题的医疗服务商事主体",
      },
      {
        id: "165",
        industryId: "21474838620",
        industryName: "妇产医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供女性怀孕、分娩服务的医疗服务商事主体",
      },
      {
        id: "166",
        industryId: "21474838621",
        industryName: "皮肤专科医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "专门提供皮肤科、男科、妇科等特殊专科诊疗的医疗服务商事主体",
      },
      {
        id: "167",
        industryId: "21474838622",
        industryName: "其他专科医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "提供个别医学分科的医疗商事主体，不含妇产科等有独立选项科室",
      },
      {
        id: "168",
        industryId: "21474838623",
        industryName: "眼科医院",
        level: "2",
        parentIndustryId: "21474836501",
        description: "指专门提供眼科诊疗服务的专科医疗商事主体",
      },
      {
        id: "169",
        industryId: "21474838624",
        industryName: "植发机构",
        level: "2",
        parentIndustryId: "21474836501",
        description: "以医疗手段实现特定头皮区域生发的植发商事主体。例：雍禾医疗",
      },
    ],
  },
  {
    id: "170",
    industryId: "21474836504",
    industryName: "亲子",
    level: "1",
    parentIndustryId: "0",
    description: "指生产与经销用于孕期和婴幼儿场景中的各类器具服饰的的商事主体",
    children: [
      {
        id: "171",
        industryId: "21474838891",
        industryName: "儿童服饰鞋帽箱包",
        level: "2",
        parentIndustryId: "21474836504",
        description: "制造与经销专门供给0-14岁婴童穿着的服饰鞋帽箱包的商事主体",
      },
      {
        id: "172",
        industryId: "21474838893",
        industryName: "婴幼儿食品",
        level: "2",
        parentIndustryId: "21474836504",
        description: "指制造与经销专门提供给0-3岁婴幼儿的食品的商事主体",
      },
      {
        id: "173",
        industryId: "21474838896",
        industryName: "儿童玩具",
        level: "2",
        parentIndustryId: "21474836504",
        description: "指制造与经销专门提供给0-14岁婴童的玩具的商事主体",
      },
      {
        id: "174",
        industryId: "21474838897",
        industryName: "儿童用品",
        level: "2",
        parentIndustryId: "21474836504",
        description: "制造与经销专门供给0-14岁婴童的用具的商事主体。例：贝亲",
      },
      {
        id: "175",
        industryId: "21474838898",
        industryName: "孕妇服饰及用品",
        level: "2",
        parentIndustryId: "21474836504",
        description: "指制造与经销专门提供给孕妇与产后恢复的服饰和用品的商事主体",
      },
    ],
  },
  {
    id: "176",
    industryId: "21474836508",
    industryName: "房地产",
    level: "1",
    parentIndustryId: "0",
    description: "指以土地和建筑物为经营对象,提供房地产开发、建设、经营（包括销售和租赁）、管理、维修和资讯服务的商事主体",
    children: [
      {
        id: "177",
        industryId: "21474839281",
        industryName: "房地产开发商",
        level: "2",
        parentIndustryId: "21474836508",
        description: "从事房地产项目开发、项目转让、房屋销售的商事主体，如：万科",
      },
      {
        id: "178",
        industryId: "21474839286",
        industryName: "房地产综合服务平台",
        level: "2",
        parentIndustryId: "21474836508",
        description: "指提供房地产相关资讯信息和数据服务等的平台",
      },
      {
        id: "179",
        industryId: "21474839287",
        industryName: "物业管理服务",
        level: "2",
        parentIndustryId: "21474836508",
        description: "按照物业服务合同对房屋及配套设施进行养护和管理的商事主体",
      },
      {
        id: "180",
        industryId: "21474839288",
        industryName: "房地产中介服务",
        level: "2",
        parentIndustryId: "21474836508",
        description: "提供房地产咨询、价格评估、经纪等服务的商事主体，如：链家",
      },
      {
        id: "181",
        industryId: "21474839289",
        industryName: "房地产租赁经营",
        level: "2",
        parentIndustryId: "21474836508",
        description: "对房源进行改造再出租（包括长租公寓、服务式公寓）的商事主体",
      },
    ],
  },
  {
    id: "182",
    industryId: "21474836509",
    industryName: "交通运输和仓储",
    level: "1",
    parentIndustryId: "0",
    description: "运输主要包含铁路、公路、水路、空路四种方式；此处指与物流运输相关的商事主体",
    children: [
      {
        id: "183",
        industryId: "21474839386",
        industryName: "铁路货物运输",
        level: "2",
        parentIndustryId: "21474836509",
        description: "提供城际间的铁路货物运输的商事主体，例：中铁铁龙",
      },
      {
        id: "184",
        industryId: "21474839387",
        industryName: "道路货物运输",
        level: "2",
        parentIndustryId: "21474836509",
        description: "指提供所有道路的货物运输服务的商事主体",
      },
      {
        id: "185",
        industryId: "21474839389",
        industryName: "航空货物运输",
        level: "2",
        parentIndustryId: "21474836509",
        description: "指提供以货物或邮件为主的航空运输服务的商事主体",
      },
      {
        id: "186",
        industryId: "21474839390",
        industryName: "水上货物运输",
        level: "2",
        parentIndustryId: "21474836509",
        description: "指提供远洋、沿海以及内河的水上货物运输服务的商事主体",
      },
      {
        id: "187",
        industryId: "21474839391",
        industryName: "装卸搬运和仓储业",
        level: "2",
        parentIndustryId: "21474836509",
        description: "提供货物装卸搬运、仓储、运输中转、保税仓等服务的商事主体",
      },
    ],
  },
  {
    id: "188",
    industryId: "21474836511",
    industryName: "节能环保",
    level: "1",
    parentIndustryId: "0",
    description:
      "指为节约能源资源、发展循环经济、保护生态环境提供物质基础和技术保障的工作的商事主体集合。属于国家加快培育和发展的7个战略性新兴产业之一",
    children: [
      {
        id: "189",
        industryId: "21474839581",
        industryName: "污染处理",
        level: "2",
        parentIndustryId: "21474836511",
        description: "针排放和各种污染进行治理管控服务的商事主体，例：国祯环保",
      },
      {
        id: "190",
        industryId: "21474839582",
        industryName: "废旧回收",
        level: "2",
        parentIndustryId: "21474836511",
        description: "指提供有偿性的废旧处理服务的商事主体",
      },
      {
        id: "191",
        industryId: "21474839583",
        industryName: "节能设备",
        level: "2",
        parentIndustryId: "21474836511",
        description: "指制造与经销尽可能地帮助减少能源消耗量的设备设施的商事主体",
      },
      {
        id: "192",
        industryId: "21474839584",
        industryName: "环保设备",
        level: "2",
        parentIndustryId: "21474836511",
        description: "制造与经销控制环境污染、改善环境质量的设备的商事主体",
      },
      {
        id: "193",
        industryId: "21474839585",
        industryName: "环境评测",
        level: "2",
        parentIndustryId: "21474836511",
        description: "指提供环境监测、评测服务的的商事主体",
      },
    ],
  },
  {
    id: "194",
    industryId: "21474836515",
    industryName: "家装家具",
    level: "1",
    parentIndustryId: "0",
    description: "指围绕着室内装修所铺开的一系列服务与商品",
    children: [
      {
        id: "195",
        industryId: "21474839987",
        industryName: "家具建材综合服务平台",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指提供家具建材相关资讯信息和数据服务等的平台",
      },
      {
        id: "196",
        industryId: "21474839992",
        industryName: "家居建材卖场及门店",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指提供各种家具、家装建材等售卖的卖场及门店",
      },
      {
        id: "197",
        industryId: "21474839993",
        industryName: "装修环境治理",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指通过特定的方法或仪器，提供定量检测甲醛含量服务的商事主体",
      },
      {
        id: "198",
        industryId: "21474839994",
        industryName: "成品家具",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指制造或经销各类完整的家具的商事主体，除线下门店",
      },
      {
        id: "199",
        industryId: "21474839995",
        industryName: "定制家具",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指制造或经销各类特殊定制的家具的商事主体，除线下门店",
      },
      {
        id: "200",
        industryId: "21474839996",
        industryName: "家装辅材",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指制造与经销各类装修中的辅助材料的商事主体，除线下门店",
      },
      {
        id: "201",
        industryId: "21474839997",
        industryName: "家装主材",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指制造与经销各类装修中的主要材料的商事主体，除线下门店",
      },
      {
        id: "202",
        industryId: "21474839998",
        industryName: "陶瓷卫浴",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指制造与经销各类陶瓷卫浴的商事主体，除线下门店",
      },
      {
        id: "203",
        industryId: "21474839999",
        industryName: "智能家居",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指生产和经销智能家居建材以及智慧家居解决方案的商事主体",
      },
      {
        id: "204",
        industryId: "21474840000",
        industryName: "冷暖设备安装",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指提供如中央空调和家用暖气等设备设计安装服务的商事主体",
      },
      {
        id: "205",
        industryId: "21474840001",
        industryName: "软装服务",
        level: "2",
        parentIndustryId: "21474836515",
        description: "提供空间内可移动元素的装修设计服务的商事主体。例：欧普照明",
      },
      {
        id: "206",
        industryId: "21474840002",
        industryName: "设计公司",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指提供室内设计服务的商事主体",
      },
      {
        id: "207",
        industryId: "21474840003",
        industryName: "装修公司",
        level: "2",
        parentIndustryId: "21474836515",
        description: "指提供各类装修服务的商事主体",
      },
    ],
  },
  {
    id: "208",
    industryId: "21474836516",
    industryName: "通讯和IT服务",
    level: "1",
    parentIndustryId: "0",
    description: "指对信息传输、信息存储、信息接收过程中产生的技术问题或技术需求所提供的服务和设备的商事主体",
    children: [
      {
        id: "209",
        industryId: "21474840081",
        industryName: "通信运营商",
        level: "2",
        parentIndustryId: "21474836516",
        description: "运营商线上及线下营业厅，提供业务办理、充值等服务",
      },
      {
        id: "210",
        industryId: "21474840083",
        industryName: "存储支持服务商",
        level: "2",
        parentIndustryId: "21474836516",
        description: "提供数据储存托管以及网络增值服务的商事主体，如：腾讯云",
      },
      {
        id: "211",
        industryId: "21474840089",
        industryName: "物联网技术服务商",
        level: "2",
        parentIndustryId: "21474836516",
        description: "为企业提供各种物联网技术应用和支持服务的商事主体",
      },
      {
        id: "212",
        industryId: "21474840090",
        industryName: "SaaS及建站服务",
        level: "2",
        parentIndustryId: "21474836516",
        description: "提供企业级标准化软件服务，为企业搭建网站或账号页面的商事主体",
      },
      {
        id: "213",
        industryId: "21474840091",
        industryName: "企业定制化IT和信息系统",
        level: "2",
        parentIndustryId: "21474836516",
        description: "提供企业级软硬件及网络等信息技术支持和定制化方案的商事主体",
      },
      {
        id: "214",
        industryId: "21474840092",
        industryName: "通信设备",
        level: "2",
        parentIndustryId: "21474836516",
        description: "生产、经销及售卖通信设备的商事主体（不含手机等电子消费品）",
      },
    ],
  },
  {
    id: "215",
    industryId: "21474836517",
    industryName: "日用百货",
    level: "1",
    parentIndustryId: "0",
    description: "指制造与经销生活中的各类日用品与休闲用品的商事主体集合",
    children: [
      {
        id: "216",
        industryId: "21474840191",
        industryName: "厨具",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销厨房用具的的商事主体",
      },
      {
        id: "217",
        industryId: "21474840192",
        industryName: "家庭清洁用品",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销 家庭洗护化学品和工具的商事主体。例：金鱼洗洁精",
      },
      {
        id: "218",
        industryId: "21474840193",
        industryName: "女性护理",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销针对女性私密护理的用品或用具的商事主体",
      },
      {
        id: "219",
        industryId: "21474840194",
        industryName: "休闲玩具",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销提供给14岁以上青少年及成人的休闲玩具的商事主体",
      },
      {
        id: "220",
        industryId: "21474840196",
        industryName: "个人洗护",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销用于身体和头发，除口腔的日用洗护化学品的商事主体",
      },
      {
        id: "221",
        industryId: "21474840197",
        industryName: "口腔护理",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销专用于口腔的清洁日化的非电工具（非医）的商事主体",
      },
      {
        id: "222",
        industryId: "21474840199",
        industryName: "文具",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指是制造与经销日常书写用具（如：铅笔、墨水）的商事主体",
      },
      {
        id: "223",
        industryId: "21474840200",
        industryName: "家纺",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销用于家庭装饰用途的纺织品的商事主体",
      },
      {
        id: "224",
        industryId: "21474840201",
        industryName: "家居工艺品",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销用于家居装饰的用品的商事主体，如花瓶、挂画、摆件等",
      },
      {
        id: "225",
        industryId: "21474840202",
        industryName: "成人用品",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销成年人情趣用品的商事主体（非药品或医疗器械属性）",
      },
      {
        id: "226",
        industryId: "21474840203",
        industryName: "家居日用",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销生活中使用的日常生活用品（非电）的商事主体",
      },
      {
        id: "227",
        industryId: "21474840204",
        industryName: "生活用纸",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销生活用纸的商事主体（抽纸、卷纸、平板纸、湿巾等）",
      },
      {
        id: "228",
        industryId: "21474840205",
        industryName: "宠物用品",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销各类宠物专用的物品的商事主体",
      },
      {
        id: "229",
        industryId: "21474840206",
        industryName: "乐器",
        level: "2",
        parentIndustryId: "21474836517",
        description: "指制造与经销各种乐器（如吉他、钢琴等）的商事主体",
      },
      {
        id: "230",
        industryId: "21474840207",
        industryName: "鲜花绿植",
        level: "2",
        parentIndustryId: "21474836517",
        description: "制造与经销有一定品牌的鲜花绿植产品的商事主体，非门店、非种植",
      },
    ],
  },
  {
    id: "231",
    industryId: "21474836519",
    industryName: "国家机构协会和社会工作",
    level: "1",
    parentIndustryId: "0",
    description: "指维系国家运转的公职机构，以及维持社会运转、不以盈利为目的工作团体和组织",
    children: [
      {
        id: "232",
        industryId: "21474840383",
        industryName: "公益组织",
        level: "2",
        parentIndustryId: "21474836519",
        description: "用捐赠从事公益，符合《基金会管理条例》的规定的非营利性法人",
      },
      {
        id: "233",
        industryId: "21474840384",
        industryName: "境外政府组织",
        level: "2",
        parentIndustryId: "21474836519",
        description: "指中国大陆境外政府组织、政府关联机构及其他官方代表机构",
      },
      {
        id: "234",
        industryId: "21474840385",
        industryName: "国际组织",
        level: "2",
        parentIndustryId: "21474836519",
        description: "指多个国家基于特定目的，以一定的协议形式而建立的机构",
      },
      {
        id: "235",
        industryId: "21474840386",
        industryName: "境外机构及NGO",
        level: "2",
        parentIndustryId: "21474836519",
        description: "指各中国大陆境外机构、国际非盈利组织和非政府组织",
      },
      {
        id: "236",
        industryId: "21474840388",
        industryName: "国家党政机关及事业单位",
        level: "2",
        parentIndustryId: "21474836519",
        description: "中国境内的国家机关、党政机关，国有资产举办的社会服务组织",
      },
      {
        id: "237",
        industryId: "21474840389",
        industryName: "社会保障",
        level: "2",
        parentIndustryId: "21474836519",
        description: "提供社会保险或保障机制的国家组织，帮助公民面对某些社会风险",
      },
      {
        id: "238",
        industryId: "21474840390",
        industryName: "社会工作",
        level: "2",
        parentIndustryId: "21474836519",
        description: "指提供救助、福利、护理、帮助等社会工作活动的组织",
      },
      {
        id: "239",
        industryId: "21474840391",
        industryName: "社会团体",
        level: "2",
        parentIndustryId: "21474836519",
        description: "指依法在社会团体登记管理机关登记备案的各类非宗教单位",
      },
    ],
  },
  {
    id: "240",
    industryId: "21474836521",
    industryName: "汽车",
    level: "1",
    parentIndustryId: "0",
    description:
      "指从事汽车的生产、销售（包括各类汽车周边物品）、售后、美容、资讯服务和汽车专用周边商品的售卖的商事主体，也包括汽车驾驶人员培训的商事主体集合",
    children: [
      {
        id: "241",
        industryId: "21474840583",
        industryName: "汽车综合服务平台",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指提供汽车相关资讯、数据比较、交易等服务的线上平台",
      },
      {
        id: "242",
        industryId: "21474840590",
        industryName: "二手车经营",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指提供二手车鉴定、收购、租赁以及出售等服务的线下卖场及门店",
      },
      {
        id: "243",
        industryId: "21474840591",
        industryName: "驾校",
        level: "2",
        parentIndustryId: "21474836521",
        description: "对驾驶人按照机动车驾驶员素质教育大纲进行培训的商事主体",
      },
      {
        id: "244",
        industryId: "21474840592",
        industryName: "汽车-4S店/经销商",
        level: "2",
        parentIndustryId: "21474836521",
        description: "整车销售、零配件、售后、信息反馈四位一体的销售门店或经销商",
      },
      {
        id: "245",
        industryId: "21474840593",
        industryName: "车辆养护服务",
        level: "2",
        parentIndustryId: "21474836521",
        description: "提供车辆清洗、养护等服务的商事主体，如：途虎",
      },
      {
        id: "246",
        industryId: "21474840594",
        industryName: "汽车配件",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指专门生产与经销汽车部件、汽车零配件的厂商",
      },
      {
        id: "247",
        industryId: "21474840595",
        industryName: "汽车厂商-合资",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指由中方与国外投资方共同成立的汽车品牌的制造厂商",
      },
      {
        id: "248",
        industryId: "21474840596",
        industryName: "汽车厂商-外资",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指外资汽车品牌或进口车制造厂商，例：劳斯莱斯",
      },
      {
        id: "249",
        industryId: "21474840597",
        industryName: "汽车厂商-自主",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指由中方自主开发，拥有自主知识产权的汽车品牌的制造厂商",
      },
      {
        id: "250",
        industryId: "21474840598",
        industryName: "专用车辆厂商",
        level: "2",
        parentIndustryId: "21474836521",
        description: "用于特殊作业的无轨车辆（如：叉车）及相关配套制造厂商",
      },
      {
        id: "251",
        industryId: "21474840599",
        industryName: "汽车养护品",
        level: "2",
        parentIndustryId: "21474836521",
        description: "汽车养护过程中使用到的用品，如：机油、雨刮水",
      },
      {
        id: "252",
        industryId: "21474840600",
        industryName: "汽车装饰品",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指生产与经销各类用于汽车装饰的装饰品的厂商",
      },
      {
        id: "253",
        industryId: "21474840601",
        industryName: "摩托和助力车厂商",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指生产与经销摩托车与助力车（包括电动车）及其零配件的厂商",
      },
      {
        id: "254",
        industryId: "21474840602",
        industryName: "摩托和助力车卖场及门店",
        level: "2",
        parentIndustryId: "21474836521",
        description: "指经营摩托车和电动助力车销售的线下门店",
      },
    ],
  },
  {
    id: "255",
    industryId: "21474836522",
    industryName: "软件工具",
    level: "1",
    parentIndustryId: "0",
    description: "指各种PC和移动端程序与软件，主要服务于用户办公、听歌、拍照等使用场景",
    children: [
      {
        id: "256",
        industryId: "21474840681",
        industryName: "办公工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "办公场景中使用的应用程序，如：邮箱、表格文档、企业通讯",
      },
      {
        id: "257",
        industryId: "21474840685",
        industryName: "摄影摄像工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指提供照片拍摄和视频录制功能的软件应用，如：黄油相机",
      },
      {
        id: "258",
        industryId: "21474840686",
        industryName: "天气日历",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指气象预警应用、天气预报应用、日历以及日程管理应用",
      },
      {
        id: "259",
        industryId: "21474840687",
        industryName: "社交工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指专门用于交友、陌生人社交和特定场景社交的软件应用",
      },
      {
        id: "260",
        industryId: "21474840688",
        industryName: "通讯工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指通过即时通讯技术来实现在线聊天、交流的软件应用，如：QQ",
      },
      {
        id: "261",
        industryId: "21474840691",
        industryName: "地图导航",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指提供驾驶指引、道路导航的软件应用",
      },
      {
        id: "262",
        industryId: "21474840692",
        industryName: "体育健康工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指提供体育运动和健康监测等辅助功能的软件应用，如：keep",
      },
      {
        id: "263",
        industryId: "21474840693",
        industryName: "操作系统",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指管理计算机硬件与软件资源的计算机程序，如：Linux、鸿蒙",
      },
      {
        id: "264",
        industryId: "21474840694",
        industryName: "开发工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "为软件开发提供支撑的工具或集成环境，如：FrontPage",
      },
      {
        id: "265",
        industryId: "21474840695",
        industryName: "视频播放与编辑工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指用于视频播放和剪辑的软件应用，如：爱剪辑",
      },
      {
        id: "266",
        industryId: "21474840696",
        industryName: "图形图像美化",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指提供图片编辑和美化的软件应用，如：美图秀秀、faceu",
      },
      {
        id: "267",
        industryId: "21474840697",
        industryName: "网络工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指用于连接互联网，支持在线浏览、上传、下载功能的软件应用",
      },
      {
        id: "268",
        industryId: "21474840698",
        industryName: "网络赚钱工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "让用户完成在线任务（观看视频、下载应用）来获取收益并提现应用",
      },
      {
        id: "269",
        industryId: "21474840699",
        industryName: "系统美化",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指通过美化修饰操作系统外观的软件应用",
      },
      {
        id: "270",
        industryId: "21474840700",
        industryName: "音乐播放与编辑工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指用于音频播放、录制和剪辑的软件应用，如：winamp",
      },
      {
        id: "271",
        industryId: "21474840701",
        industryName: "阅读与听书工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指阅读、播放电子书籍或文档内容的工具软件，如：iReader",
      },
      {
        id: "272",
        industryId: "21474840702",
        industryName: "安全清理",
        level: "2",
        parentIndustryId: "21474836522",
        description: "指提供安全保护、设备加速、垃圾清理等系统管理功能的应用",
      },
      {
        id: "273",
        industryId: "21474840703",
        industryName: "系统工具与效率工具",
        level: "2",
        parentIndustryId: "21474836522",
        description: "提升系统使用体验和工作效率的应用，如：输入法、磁盘管理",
      },
    ],
  },
  {
    id: "274",
    industryId: "21474836523",
    industryName: "游戏",
    level: "1",
    parentIndustryId: "0",
    description: "指制作与发行基于电子设备平台运行的交互游戏的商事主体，和提供游戏资讯及周边服务的平台",
    children: [
      {
        id: "275",
        industryId: "21474840781",
        industryName: "角色扮演",
        level: "2",
        parentIndustryId: "21474836523",
        description: "玩家负责扮演这个角色在一个写实或虚构世界中活动，简称RPG",
      },
      {
        id: "276",
        industryId: "21474840782",
        industryName: "策略",
        level: "2",
        parentIndustryId: "21474836523",
        description: "玩家运用策略，与敌方较量并达成胜利条件，简称SLG游戏",
      },
      {
        id: "277",
        industryId: "21474840783",
        industryName: "体育",
        level: "2",
        parentIndustryId: "21474836523",
        description: "让玩家可以参与专业的体育运动项目的游戏，简称SPG游戏",
      },
      {
        id: "278",
        industryId: "21474840784",
        industryName: "棋牌",
        level: "2",
        parentIndustryId: "21474836523",
        description: "传统的棋类、牌类、麻将类以及经典捕鱼游戏，如：欢乐斗地主",
      },
      {
        id: "279",
        industryId: "21474840785",
        industryName: "音乐",
        level: "2",
        parentIndustryId: "21474836523",
        description: "培养玩家音乐敏感性，增强音乐感知的音乐游戏。例：节奏大师",
      },
      {
        id: "280",
        industryId: "21474840786",
        industryName: "模拟经营",
        level: "2",
        parentIndustryId: "21474836523",
        description: "由玩家对游戏中虚拟的世界进行经营管理的游戏",
      },
      {
        id: "281",
        industryId: "21474840787",
        industryName: "休闲",
        level: "2",
        parentIndustryId: "21474836523",
        description: "上手很快、无须长时间进行，休闲成分较重的游戏。例：消消乐",
      },
      {
        id: "282",
        industryId: "21474840788",
        industryName: "益智",
        level: "2",
        parentIndustryId: "21474836523",
        description: "以游戏的形式锻炼人的逻辑力和敏捷力的游戏。例：割绳子、围棋",
      },
      {
        id: "283",
        industryId: "21474840789",
        industryName: "射击",
        level: "2",
        parentIndustryId: "21474836523",
        description: "以枪或载具射击为核心元素的竟技游戏，简称STG。例：绝地求生",
      },
      {
        id: "284",
        industryId: "21474840790",
        industryName: "养成",
        level: "2",
        parentIndustryId: "21474836523",
        description: "以角色养成为核心的游戏，玩家会有强烈的养成感。",
      },
      {
        id: "285",
        industryId: "21474840791",
        industryName: "格斗",
        level: "2",
        parentIndustryId: "21474836523",
        description: "玩家分为两个或多个阵营作战，使用格斗技巧击败对手来获取胜利",
      },
      {
        id: "286",
        industryId: "21474840792",
        industryName: "冒险",
        level: "2",
        parentIndustryId: "21474836523",
        description: "由玩家控制游戏人物进行虚拟冒险的游戏，简称AVG",
      },
      {
        id: "287",
        industryId: "21474840793",
        industryName: "卡牌",
        level: "2",
        parentIndustryId: "21474836523",
        description: "以收集与使用卡牌为核心元素的游戏。例:炉石传说、阴阳师",
      },
      {
        id: "288",
        industryId: "21474840794",
        industryName: "竞速",
        level: "2",
        parentIndustryId: "21474836523",
        description: "模拟各类赛车运动的游戏，简称RCG。例：QQ飞车",
      },
      {
        id: "289",
        industryId: "21474840796",
        industryName: "MOBA",
        level: "2",
        parentIndustryId: "21474836523",
        description: "多人在线战术竞技，打钱升级，攻占对方核心的游戏，如：王者荣耀",
      },
      {
        id: "290",
        industryId: "21474840797",
        industryName: "电子竞技",
        level: "2",
        parentIndustryId: "21474836523",
        description: "经营电子竞技相关活动的商事主体（包括赛事、俱乐部等）",
      },
      {
        id: "291",
        industryId: "21474840798",
        industryName: "网络赚钱游戏",
        level: "2",
        parentIndustryId: "21474836523",
        description: "引导用户在完成在线任务，最终获取收益并提现或兑换奖品的游戏",
      },
      {
        id: "292",
        industryId: "21474840799",
        industryName: "游戏综合服务平台",
        level: "2",
        parentIndustryId: "21474836523",
        description: "围绕游戏主题的综合性娱乐平台，包含资讯和社区，如：3dm",
      },
    ],
  },
  {
    id: "293",
    industryId: "21474836526",
    industryName: "农林牧渔和采矿",
    level: "1",
    parentIndustryId: "0",
    description: "指农业、林业、畜牧业、渔业和采矿业",
    children: [
      {
        id: "294",
        industryId: "21474841081",
        industryName: "兽医兽药",
        level: "2",
        parentIndustryId: "21474836526",
        description: "制造或经销用于家畜疾病或调节家畜生理机能的药物的商事主体",
      },
      {
        id: "295",
        industryId: "21474841082",
        industryName: "农药化肥",
        level: "2",
        parentIndustryId: "21474836526",
        description: "制造与经销 处理危害农林业的农用药物和肥料的商事主体",
      },
      {
        id: "296",
        industryId: "21474841083",
        industryName: "种植养殖",
        level: "2",
        parentIndustryId: "21474836526",
        description: "从事农业、畜牧、渔业生产加工生态的商事主体，例：北大荒农垦",
      },
      {
        id: "297",
        industryId: "21474841084",
        industryName: "园林景观",
        level: "2",
        parentIndustryId: "21474836526",
        description: "进行林业生产加工生态的商事主体，如观赏性花木、园林设施",
      },
      {
        id: "298",
        industryId: "21474841085",
        industryName: "采矿业",
        level: "2",
        parentIndustryId: "21474836526",
        description: "提供对固体、液体或气体等自然产生的矿物的采掘活动的的商事主体",
      },
      {
        id: "299",
        industryId: "21474841086",
        industryName: "动物饲料",
        level: "2",
        parentIndustryId: "21474836526",
        description: "生产和经销用于动物饲牧、喂养食品（如：饲草）的商事主体",
      },
    ],
  },
  {
    id: "300",
    industryId: "21474836527",
    industryName: "出版发行",
    level: "1",
    parentIndustryId: "0",
    description: "指对图书、报刊杂志、音像制品及广播电视电影内容进行加工和出版的机构",
    children: [
      {
        id: "301",
        industryId: "21474841183",
        industryName: "广播电视发行",
        level: "2",
        parentIndustryId: "21474836527",
        description: "对广播、电视节目和电影进行出版、宣发等相关工作的机构",
      },
      {
        id: "302",
        industryId: "21474841185",
        industryName: "报纸出版",
        level: "2",
        parentIndustryId: "21474836527",
        description: "指完成报纸内容编辑与出版印刷，将其销售给读者的机构",
      },
      {
        id: "303",
        industryId: "21474841186",
        industryName: "期刊杂志出版",
        level: "2",
        parentIndustryId: "21474836527",
        description: "指完成期刊杂志的内容编辑与出版印刷，并将其销售给读者的机构",
      },
      {
        id: "304",
        industryId: "21474841187",
        industryName: "图书出版",
        level: "2",
        parentIndustryId: "21474836527",
        description: "对书籍、地图、日历等进行编辑、出版或发行的商事主体",
      },
      {
        id: "305",
        industryId: "21474841188",
        industryName: "电影发行",
        level: "2",
        parentIndustryId: "21474836527",
        description: "指院线电影的制作、发行、宣发机构，如索尼影视，华策影业等",
      },
      {
        id: "306",
        industryId: "21474841189",
        industryName: "音像制品出版",
        level: "2",
        parentIndustryId: "21474836527",
        description: "对多媒体内容载体（录音带、唱片等）进行合法复制、出版发行",
      },
    ],
  },
  {
    id: "307",
    industryId: "21474836528",
    industryName: "数码家电",
    level: "1",
    parentIndustryId: "0",
    description:
      "“数码”指的是含有“数码技术”的数码产品，家用电器，是指以电能来进行驱动的家庭电器用具，指生产与经销指生活中所常用的各类由电力驱动的数码电子产品和电子器具的商事主体集合",
    children: [
      {
        id: "308",
        industryId: "21474841293",
        industryName: "电脑",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销各类电脑产品的商事主体",
      },
      {
        id: "309",
        industryId: "21474841294",
        industryName: "手机",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销各类手机产品的商事主体",
      },
      {
        id: "310",
        industryId: "21474841295",
        industryName: "摄影摄像设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销各类摄影摄像电子产品的商事主体",
      },
      {
        id: "311",
        industryId: "21474841296",
        industryName: "数码配件",
        level: "2",
        parentIndustryId: "21474836528",
        description: "制造与经销各类电子产品配件，数码配件，电脑周边配件的商事主体",
      },
      {
        id: "312",
        industryId: "21474841297",
        industryName: "视听设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销各类影像音乐相关电子产品的商事主体",
      },
      {
        id: "313",
        industryId: "21474841298",
        industryName: "办公设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "制造与经销用于办公室、商事主体等场所的电子办公产品的商事主体",
      },
      {
        id: "314",
        industryId: "21474841299",
        industryName: "教育电子设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销带有教育功能的电子产品的商事主体",
      },
      {
        id: "315",
        industryId: "21474841300",
        industryName: "个人智能设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "制造与经销个人日常生活使用的智能电子产品的商事主体。例：云米",
      },
      {
        id: "316",
        industryId: "21474841301",
        industryName: "家用电器",
        level: "2",
        parentIndustryId: "21474836528",
        description: "制造与经销日常生活环境使用的各种电器的商事主体，如：格力",
      },
      {
        id: "317",
        industryId: "21474841303",
        industryName: "电子游戏设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销游戏设备和游戏周边设备的商事主体",
      },
      {
        id: "318",
        industryId: "21474841305",
        industryName: "按摩电子设备",
        level: "2",
        parentIndustryId: "21474836528",
        description: "制造与经销按摩电子设备（非治疗目的）的商事主体",
      },
      {
        id: "319",
        industryId: "21474841306",
        industryName: "个护电器",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销个人护理类的小家电（含电动牙刷）的商事主体",
      },
      {
        id: "320",
        industryId: "21474841307",
        industryName: "美容电子仪器",
        level: "2",
        parentIndustryId: "21474836528",
        description: "指制造与经销在日常化妆和美容时所使用的电子产品的商事主体",
      },
    ],
  },
  {
    id: "321",
    industryId: "21474836530",
    industryName: "餐饮",
    level: "1",
    parentIndustryId: "0",
    description:
      "餐饮业是指在一定场所，对食物进行现场烹饪、调制，并出售给顾客，主要供现场消费的服务活动。包括中西餐厅、快餐、饮料店、顾客外卖自提等形式",
    children: [
      {
        id: "322",
        industryId: "21474841481",
        industryName: "烘焙甜品",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指专门提供面包、蛋糕、甜品的餐饮服务商事主体",
      },
      {
        id: "323",
        industryId: "21474841482",
        industryName: "咖啡店",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供咖啡以及休闲场所服务的店铺",
      },
      {
        id: "324",
        industryId: "21474841484",
        industryName: "西餐",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供欧式、美式及类似形式西餐正餐服务的商事主体",
      },
      {
        id: "325",
        industryId: "21474841485",
        industryName: "火锅串串",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供各种类型的火锅、串串、涮煮正餐服务的商事主体",
      },
      {
        id: "326",
        industryId: "21474841486",
        industryName: "自助餐",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供各种类型自助餐服务的商事主体",
      },
      {
        id: "327",
        industryId: "21474841487",
        industryName: "烧烤烤肉",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供各种类型的烧烤类正餐服务的商事主体",
      },
      {
        id: "328",
        industryId: "21474841491",
        industryName: "国外美食",
        level: "2",
        parentIndustryId: "21474836530",
        description: "提供西餐以外海外风味正餐服务的商事主体，如韩餐、日式料理",
      },
      {
        id: "329",
        industryId: "21474841492",
        industryName: "西式快餐",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供全天就餐的西式简便餐饮服务，包括汉堡薯条以及三明治等",
      },
      {
        id: "330",
        industryId: "21474841493",
        industryName: "小吃卤味",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供卤味、炸串等各种小吃的餐饮服务",
      },
      {
        id: "331",
        industryId: "21474841494",
        industryName: "中式快餐",
        level: "2",
        parentIndustryId: "21474836530",
        description: "提供中式简便餐饮服务（含流动餐饮）的商事主体，例：真功夫",
      },
      {
        id: "332",
        industryId: "21474841495",
        industryName: "冰淇淋店",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指专门提供冰淇淋的餐饮服务商事主体",
      },
      {
        id: "333",
        industryId: "21474841496",
        industryName: "茶饮果汁",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供各类奶茶、果茶以及果汁等饮品的餐饮服务",
      },
      {
        id: "334",
        industryId: "21474841497",
        industryName: "酒吧",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供各种酒水饮料现场消费服务的商事主体",
      },
      {
        id: "335",
        industryId: "21474841498",
        industryName: "中国地方菜系",
        level: "2",
        parentIndustryId: "21474836530",
        description: "指提供中国地方菜系（如粤菜、川菜）正餐服务的商事主体",
      },
    ],
  },
  {
    id: "336",
    industryId: "21474836531",
    industryName: "零售和百货",
    level: "1",
    parentIndustryId: "0",
    description: "指直接将各种商品售卖给消费者的商事主体集合。包括综合卖场（其所售卖的商品涵盖各个品类），以及各个品类的单独专卖店。",
    children: [
      {
        id: "337",
        industryId: "21474841581",
        industryName: "超市",
        level: "2",
        parentIndustryId: "21474836531",
        description: "以自选销售方式，以销售大众化实用品为主的零售业态，如物美超市",
      },
      {
        id: "338",
        industryId: "21474841582",
        industryName: "便利店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "经营即时性商品或服务的实体店，例：便利店、食杂店等",
      },
      {
        id: "339",
        industryId: "21474841583",
        industryName: "购物中心",
        level: "2",
        parentIndustryId: "21474836531",
        description: "向消费者提供综合性服务的商业集合体。例：欢乐海岸、国贸商城",
      },
      {
        id: "340",
        industryId: "21474841584",
        industryName: "综合百货",
        level: "2",
        parentIndustryId: "21474836531",
        description: "经营服饰、化妆品等品类，满足顾客追求生活时尚的零售业态",
      },
      {
        id: "341",
        industryId: "21474841585",
        industryName: "服饰鞋帽箱包卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种服饰鞋帽箱包售卖的卖场及门店",
      },
      {
        id: "342",
        industryId: "21474841586",
        industryName: "护肤彩妆卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种化妆品、美容工具售卖的卖场及线下门店",
      },
      {
        id: "343",
        industryId: "21474841587",
        industryName: "亲子卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种母婴用品售卖的卖场及线下门店",
      },
      {
        id: "344",
        industryId: "21474841588",
        industryName: "日用百货卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "日用杂货、书本和音像制品卖场及线下门店",
      },
      {
        id: "345",
        industryId: "21474841589",
        industryName: "食品卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种食品售卖的卖场及线下门店",
      },
      {
        id: "346",
        industryId: "21474841590",
        industryName: "数码家电卖场和门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种数码家电产品售卖的卖场及线下门店",
      },
      {
        id: "347",
        industryId: "21474841591",
        industryName: "运动户外卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种运动户外用品售卖的卖场及线下门店",
      },
      {
        id: "348",
        industryId: "21474841592",
        industryName: "珠宝钟表眼镜卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种珠宝钟表和眼镜售卖的卖场及线下门店",
      },
      {
        id: "349",
        industryId: "21474841593",
        industryName: "成人用品卖场及门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指销售成人情趣用品的卖场及线下门店",
      },
      {
        id: "350",
        industryId: "21474841594",
        industryName: "酒类卖场和门店",
        level: "2",
        parentIndustryId: "21474836531",
        description: "指提供各种酒类售卖的卖场及线下门店",
      },
    ],
  },
  {
    id: "351",
    industryId: "21474836535",
    industryName: "服饰鞋帽箱包",
    level: "1",
    parentIndustryId: "0",
    description: "指各类生产与经销各类服饰鞋帽箱包的商事主体",
    children: [
      {
        id: "352",
        industryId: "21474841981",
        industryName: "服装",
        level: "2",
        parentIndustryId: "21474836535",
        description: "指制造与经销各种类的服装的商事主体",
      },
      {
        id: "353",
        industryId: "21474841982",
        industryName: "贴身衣物",
        level: "2",
        parentIndustryId: "21474836535",
        description: "指制造与经销具有各种不同功能区分的贴身衣物的商事主体",
      },
      {
        id: "354",
        industryId: "21474841983",
        industryName: "一般服装配饰",
        level: "2",
        parentIndustryId: "21474836535",
        description: "制造与经销 烘托效果的非主干部位的非贵重配饰 的商事主体",
      },
      {
        id: "355",
        industryId: "21474841984",
        industryName: "鞋类",
        level: "2",
        parentIndustryId: "21474836535",
        description: "指制造与经销具有各种不同功能区分的鞋子（除运动鞋）的商事主体",
      },
      {
        id: "356",
        industryId: "21474841985",
        industryName: "袜类",
        level: "2",
        parentIndustryId: "21474836535",
        description: "指制造与经销具有各种不同功能区分的袜子的商事主体",
      },
      {
        id: "357",
        industryId: "21474841986",
        industryName: "帽类",
        level: "2",
        parentIndustryId: "21474836535",
        description: "制造与经销 不同功能的帽子（除户外运动）的商事主体",
      },
      {
        id: "358",
        industryId: "21474841988",
        industryName: "箱包",
        level: "2",
        parentIndustryId: "21474836535",
        description: "指制造与经销具有各种不同功能区分的箱包的商事主体",
      },
    ],
  },
  {
    id: "359",
    industryId: "21474836536",
    industryName: "工业工程和安保",
    level: "1",
    parentIndustryId: "0",
    description: "指各种轻工业与重工业行业以及安保行业",
    children: [
      {
        id: "360",
        industryId: "21474842081",
        industryName: "保安安保",
        level: "2",
        parentIndustryId: "21474836536",
        description: "指提供安保人力、安保器材等相关服务或器具的商事主体",
      },
      {
        id: "361",
        industryId: "21474842082",
        industryName: "防盗报警",
        level: "2",
        parentIndustryId: "21474836536",
        description: "指制造与经销用于防盗报警用途相关器材的商事主体",
      },
      {
        id: "362",
        industryId: "21474842083",
        industryName: "交通消防",
        level: "2",
        parentIndustryId: "21474836536",
        description: "指制造与经销用于灭火、防火以及火灾事故救灾的器材的商事主体",
      },
      {
        id: "363",
        industryId: "21474842085",
        industryName: "门禁考勤",
        level: "2",
        parentIndustryId: "21474836536",
        description: "制造或经销用于人事考勤管理等用途的出入口自动控制系统的企业",
      },
      {
        id: "364",
        industryId: "21474842086",
        industryName: "电子电工",
        level: "2",
        parentIndustryId: "21474836536",
        description: "指从事各类电子设备维护、制造和应用贸易的商事主体",
      },
      {
        id: "365",
        industryId: "21474842087",
        industryName: "机械设备",
        level: "2",
        parentIndustryId: "21474836536",
        description: "电气设备生产和租赁商事主体、建筑施工、工业贸易经销商",
      },
      {
        id: "366",
        industryId: "21474842088",
        industryName: "化工材料和制品",
        level: "2",
        parentIndustryId: "21474836536",
        description: "指制造与经销各类化工原料、材料与制品的商事主体",
      },
    ],
  },
  {
    id: "367",
    industryId: "21474836537",
    industryName: "能源和供应",
    level: "1",
    parentIndustryId: "0",
    description: "指为满足能源需求而对各种形式能源的开发和利用以及提供该能源的输送和分配的商事主体集合",
    children: [
      {
        id: "368",
        industryId: "21474842181",
        industryName: "电力热力生产和供应",
        level: "2",
        parentIndustryId: "21474836537",
        description: "向用户输送的供电活动以及生产蒸汽和热水的活动",
      },
      {
        id: "369",
        industryId: "21474842182",
        industryName: "燃气生产和供应",
        level: "2",
        parentIndustryId: "21474836537",
        description: "生产或外购燃气，向用户出售输配和过程中的维修管理活动",
      },
      {
        id: "370",
        industryId: "21474842183",
        industryName: "燃油生产和供应",
        level: "2",
        parentIndustryId: "21474836537",
        description: "指专门经营机动车燃油的生产销售活动",
      },
      {
        id: "371",
        industryId: "21474842184",
        industryName: "水的生产和供应",
        level: "2",
        parentIndustryId: "21474836537",
        description: "蓄集净化天然水达到标准，并向用户供应的活动。例：北控水务",
      },
    ],
  },
  {
    id: "372",
    industryId: "21474836538",
    industryName: "商务服务",
    level: "1",
    parentIndustryId: "0",
    description: "指为商业社会运行提供各类专业服务的商事主体",
    children: [
      {
        id: "373",
        industryId: "21474842281",
        industryName: "办公场景服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指提供办公场景工作空间解决方案的商事主体，例：wework",
      },
      {
        id: "374",
        industryId: "21474842282",
        industryName: "互联网代理运营服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "面向企业提供互联网代理运营服务的商事主体",
      },
      {
        id: "375",
        industryId: "21474842283",
        industryName: "环保咨询",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指为第三方提供环境保护、解决潜在环境问题等咨询服务的商事主体",
      },
      {
        id: "376",
        industryId: "21474842284",
        industryName: "信用服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "专门从事信用信息处理、提供相关信用产品和信用服务的商事主体",
      },
      {
        id: "377",
        industryId: "21474842285",
        industryName: "营销策划与服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "提供多渠道营销策划、解决方案等专业营销的服务商事主体",
      },
      {
        id: "378",
        industryId: "21474842286",
        industryName: "公证服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "对有法律意义的行为、事实，文书合法性予以证明的活动。",
      },
      {
        id: "379",
        industryId: "21474842287",
        industryName: "律师及法律服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指提供各种法律服务的律所与律师",
      },
      {
        id: "380",
        industryId: "21474842288",
        industryName: "司法鉴定",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指运用专业知识与技术鉴别和判断法律事实真实性的相关商事主体",
      },
      {
        id: "381",
        industryId: "21474842289",
        industryName: "出国中介",
        level: "2",
        parentIndustryId: "21474836538",
        description: "为中国公民出国从事非公活动提供全面服务的商事主体",
      },
      {
        id: "382",
        industryId: "21474842290",
        industryName: "商务代理代办服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指为商事主体提供的各种代理、代办（含代招投标）服务的商事主体",
      },
      {
        id: "383",
        industryId: "21474842291",
        industryName: "翻译服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指专业提供口译或笔译服务的个人或商事主体",
      },
      {
        id: "384",
        industryId: "21474842292",
        industryName: "管理咨询",
        level: "2",
        parentIndustryId: "21474836538",
        description: "为商事主体提供管理咨询服务的商事主体和公司，不含投资、证券",
      },
      {
        id: "385",
        industryId: "21474842293",
        industryName: "广告包装设计制作",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指为客户提供策划制作，在多渠道上进行宣传推广活动的商事主体",
      },
      {
        id: "386",
        industryId: "21474842294",
        industryName: "拍卖服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "以拍卖形式为买卖双方（代表委托人）提供贸易机会的商事主体",
      },
      {
        id: "387",
        industryId: "21474842295",
        industryName: "配音服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指提供影视、动画、宣传片配音等专业配音服务的商事主体",
      },
      {
        id: "388",
        industryId: "21474842296",
        industryName: "市场调查",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指专门提供调查服务的商事主体和公司，含广播电视收听、收视调查",
      },
      {
        id: "389",
        industryId: "21474842297",
        industryName: "喷绘印刷",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指提供将原稿上的图文信息转移到承印物上的服务的商事主体",
      },
      {
        id: "390",
        industryId: "21474842298",
        industryName: "营销机构",
        level: "2",
        parentIndustryId: "21474836538",
        description: "提供社交平台营销、搜索引擎营销专业营销支持服务的商事主体",
      },
      {
        id: "391",
        industryId: "21474842299",
        industryName: "会展服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "提供举办会议、展览所需的策划、场地、安保等服务的商事主体",
      },
      {
        id: "392",
        industryId: "21474842300",
        industryName: "婚恋会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以婚恋为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "393",
        industryId: "21474842301",
        industryName: "家居会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以家居为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "394",
        industryId: "21474842302",
        industryName: "旅游会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以旅游为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "395",
        industryId: "21474842303",
        industryName: "贸易会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以商品贸易为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "396",
        industryId: "21474842304",
        industryName: "汽车会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以汽车为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "397",
        industryId: "21474842305",
        industryName: "文体会展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以文化体育为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "398",
        industryId: "21474842306",
        industryName: "消费品展",
        level: "2",
        parentIndustryId: "21474836538",
        description: "指以消费品为主题的会议、展览，也可附带其他相关的活动形式",
      },
      {
        id: "399",
        industryId: "21474842307",
        industryName: "代理记账",
        level: "2",
        parentIndustryId: "21474836538",
        description: "进行代理记账类服务支持",
      },
      {
        id: "400",
        industryId: "21474842308",
        industryName: "评估清算",
        level: "2",
        parentIndustryId: "21474836538",
        description: "提供资产评估、破产清算等服务支持",
      },
      {
        id: "401",
        industryId: "21474842309",
        industryName: "审计服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "提供财务审、收支、离任、内控等专项审计/验资/尽调服务",
      },
      {
        id: "402",
        industryId: "21474842310",
        industryName: "税收筹划",
        level: "2",
        parentIndustryId: "21474836538",
        description: "进行税务相关的筹划、申报、退税等服务",
      },
      {
        id: "403",
        industryId: "21474842311",
        industryName: "人力资源服务",
        level: "2",
        parentIndustryId: "21474836538",
        description: "为劳动者就业发展、为用人单位管理和开发人力资源提供的相关服务",
      },
      {
        id: "404",
        industryId: "21474842312",
        industryName: "招聘猎头平台",
        level: "2",
        parentIndustryId: "21474836538",
        description: "招聘、猎头、人才服务机构或求职应聘类网站。例：智联招聘",
      },
    ],
  },
  {
    id: "405",
    industryId: "21474836539",
    industryName: "科研和技术服务",
    level: "1",
    parentIndustryId: "0",
    description: "指科学或社会科学研究工作，以及与科学技术创新相关的支撑服务的商事主体集合",
    children: [
      {
        id: "406",
        industryId: "21474842381",
        industryName: "科学技术服务",
        level: "2",
        parentIndustryId: "21474836539",
        description: "科研机构、提供科技创新支撑服务的机构、提供科技成果服务的机构",
      },
      {
        id: "407",
        industryId: "21474842382",
        industryName: "知识产权服务",
        level: "2",
        parentIndustryId: "21474836539",
        description: "对各类知识产权的一系列相关服务。例：超凡知识产权",
      },
    ],
  },
  {
    id: "408",
    industryId: "21474836540",
    industryName: "文化体育娱乐活动",
    level: "1",
    parentIndustryId: "0",
    description: "指围绕文化、体育、娱乐活动提供场地、举办服务、参与人员代理和资讯服务的各类商事主体，娱乐活动包含彩票",
    children: [
      {
        id: "409",
        industryId: "21474842481",
        industryName: "体育俱乐部",
        level: "2",
        parentIndustryId: "21474836540",
        description: "以雇用或租用职业运动员参加竞技为主要经营模式的商事主体",
      },
      {
        id: "410",
        industryId: "21474842482",
        industryName: "文化艺术体育场馆",
        level: "2",
        parentIndustryId: "21474836540",
        description: "举办文艺体育活动和展览的场所，如：体育馆、博物馆、展览馆",
      },
      {
        id: "411",
        industryId: "21474842483",
        industryName: "文化艺术体育活动",
        level: "2",
        parentIndustryId: "21474836540",
        description: "文艺活动、演出、体育竞技活动（如：马拉松、演唱会）主办方",
      },
      {
        id: "412",
        industryId: "21474842484",
        industryName: "文体设备用品租赁",
        level: "2",
        parentIndustryId: "21474836540",
        description: "文体设备的租赁服务：如：球具租赁、滑翔伞租赁",
      },
      {
        id: "413",
        industryId: "21474842485",
        industryName: "彩票",
        level: "2",
        parentIndustryId: "21474836540",
        description: "营运各种彩票活动的政府机构，如：中国福利彩票发行管理中心",
      },
      {
        id: "414",
        industryId: "21474842486",
        industryName: "艺人网红经纪代理",
        level: "2",
        parentIndustryId: "21474836540",
        description: "专门为艺人或者网红提供包装、资源对接置换与运营服务的商事主体",
      },
      {
        id: "415",
        industryId: "21474842487",
        industryName: "文化艺术体育资讯综合平台",
        level: "2",
        parentIndustryId: "21474836540",
        description: "提供赛事演出信息、观看、售票途径的第三方平台。如：腾讯体育",
      },
    ],
  },
  {
    id: "416",
    industryId: "21474836541",
    industryName: "生活服务",
    level: "1",
    parentIndustryId: "0",
    description: "指满足居民基本生活需求的到家和到店的服务，一般具有区域辐射性",
    children: [
      {
        id: "417",
        industryId: "21474842581",
        industryName: "保健养生服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供推拿、按摩、刮痧、拔火罐等保健服务的商事主体（非医疗）",
      },
      {
        id: "418",
        industryId: "21474842583",
        industryName: "二手物品回收",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指以完整再出售为目的回收废旧品的第三方的回收商事主体商事主体",
      },
      {
        id: "419",
        industryId: "21474842584",
        industryName: "儿童托管",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供场所并照料、培养幼儿生活能力（非早教）的服务商事主体",
      },
      {
        id: "420",
        industryId: "21474842585",
        industryName: "管道疏通",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供针对住宅中的管道堵塞提供的疏通服务的商事主体",
      },
      {
        id: "421",
        industryId: "21474842586",
        industryName: "结婚喜品",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供婚礼上所有用到的物品的商事主体",
      },
      {
        id: "422",
        industryId: "21474842587",
        industryName: "结婚综合服务平台",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供结婚服务相关资讯信息和数据服务等的平台",
      },
      {
        id: "423",
        industryId: "21474842588",
        industryName: "刻章",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指印章的雕刻与制作服务商事主体",
      },
      {
        id: "424",
        industryId: "21474842589",
        industryName: "美体瘦身",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供对身体的塑形、减脂等美化身体的服务的商事主体",
      },
      {
        id: "425",
        industryId: "21474842590",
        industryName: "情感咨询",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指通过沟通解决情绪、情感方面心理问题的咨询服务商事主体",
      },
      {
        id: "426",
        industryId: "21474842591",
        industryName: "摄影基地场地",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供专门用于拍摄的场所基地商事主体",
      },
      {
        id: "427",
        industryId: "21474842592",
        industryName: "生活服务优惠资讯",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指为用户整合优惠资讯、向用户分发生活消费优惠券的商事主体",
      },
      {
        id: "428",
        industryId: "21474842594",
        industryName: "洗浴",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供的各类洗浴、搓澡等服务的商事主体",
      },
      {
        id: "429",
        industryId: "21474842595",
        industryName: "养老服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "为老年人提供必要的物质、精神生活需求的生活服务商事主体",
      },
      {
        id: "430",
        industryId: "21474842596",
        industryName: "专用洗护",
        level: "2",
        parentIndustryId: "21474836541",
        description: "对衣鞋包类等提供干湿洗、洗烫、染色等服务的商事主体",
      },
      {
        id: "431",
        industryId: "21474842597",
        industryName: "婚介所",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指为独身男女介绍对象的社会性服务商事主体和婚介实体门店",
      },
      {
        id: "432",
        industryId: "21474842598",
        industryName: "婚恋线上平台",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指以婚恋为目的，为用户提供在线婚恋交友服务的实名制线上平台",
      },
      {
        id: "433",
        industryId: "21474842599",
        industryName: "婚纱礼服",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指婚纱或礼服的租赁和售卖服务商事主体（涵盖男士礼服、燕尾服）",
      },
      {
        id: "434",
        industryId: "21474842600",
        industryName: "母婴护理",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供孕妇产后护理、新生儿健康护理等需求的服务商事主体",
      },
      {
        id: "435",
        industryId: "21474842601",
        industryName: "婚纱摄影",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供专注婚纱照摄影的摄影商事主体",
      },
      {
        id: "436",
        industryId: "21474842602",
        industryName: "亲子摄影",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供专注亲子摄影的摄影商事主体",
      },
      {
        id: "437",
        industryId: "21474842603",
        industryName: "爱好收藏",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指邮票和纪念币等由国家统一发行收藏品的再流通交易商事主体",
      },
      {
        id: "438",
        industryId: "21474842604",
        industryName: "搬家服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供搬家常见的装箱、搬运、运输等服务的商事主体。例：货拉拉",
      },
      {
        id: "439",
        industryId: "21474842605",
        industryName: "房屋维修",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供对房屋的养护、维修服务，如防水补漏服务的商事主体",
      },
      {
        id: "440",
        industryId: "21474842606",
        industryName: "家电维修",
        level: "2",
        parentIndustryId: "21474836541",
        description: "为家电提供更换配件、维修、改修的技术服务商事主体",
      },
      {
        id: "441",
        industryId: "21474842607",
        industryName: "家政服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "为家庭提供月嫂、保洁、护工等人力服务的商事主体",
      },
      {
        id: "442",
        industryId: "21474842608",
        industryName: "礼品卡券",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指为已预付费商家制作礼品卷的第三方服务商事主体",
      },
      {
        id: "443",
        industryId: "21474842609",
        industryName: "开锁服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指开锁、换锁、修锁等服务商事主体",
      },
      {
        id: "444",
        industryId: "21474842610",
        industryName: "美发护发",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供对头发的改善、护理、美容等服务的商事主体",
      },
      {
        id: "445",
        industryId: "21474842611",
        industryName: "生活综合服务平台",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供生活服务（含餐饮）相关资讯信息和数据服务等的平台",
      },
      {
        id: "446",
        industryId: "21474842612",
        industryName: "运动健身场所",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供身体运动、健身康复场所的商事主体。例：浩沙健身",
      },
      {
        id: "447",
        industryId: "21474842613",
        industryName: "占卜起名",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指通过占卜手段，提供未来趋势或起名的服务商事主体。例：算命网",
      },
      {
        id: "448",
        industryId: "21474842614",
        industryName: "婚礼策划",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指为客人量身打造婚礼而进行的策划服务商事主体",
      },
      {
        id: "449",
        industryId: "21474842615",
        industryName: "结婚服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指婚礼准备、新娘跟妆、婚礼跟拍、婚礼司仪等婚庆服务商事主体",
      },
      {
        id: "450",
        industryId: "21474842616",
        industryName: "个人摄影",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供专注以人为主题的摄影商事主体",
      },
      {
        id: "451",
        industryId: "21474842617",
        industryName: "商业摄影",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供按照客户需求拍摄人像、风景、产品服务的摄影商事主体",
      },
      {
        id: "452",
        industryId: "21474842618",
        industryName: "摄影摄像设备租赁",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指不配备操作人员的摄影摄像设备的租赁服务",
      },
      {
        id: "453",
        industryId: "21474842619",
        industryName: "宠物服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供宠物寄养、驯导、美容（不含诊疗）的宠物医院商事主体",
      },
      {
        id: "454",
        industryId: "21474842620",
        industryName: "乐器琴行",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指售卖乐器的实体门店商事主体，且提供一定的服务，如调音",
      },
      {
        id: "455",
        industryId: "21474842621",
        industryName: "美甲美睫",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供对睫毛和指甲进行嫁接、美化等服务的商事主体",
      },
      {
        id: "456",
        industryId: "21474842622",
        industryName: "美容/SPA",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供美容护理、皮肤保健、水疗等服务的商事主体。例：美丽田园",
      },
      {
        id: "457",
        industryId: "21474842623",
        industryName: "加油和充电站",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供车辆加油和充电的服务站点",
      },
      {
        id: "458",
        industryId: "21474842624",
        industryName: "快照洗印",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供相片拍摄冲洗、文件印刷等服务的商事主体。",
      },
      {
        id: "459",
        industryId: "21474842625",
        industryName: "快递闪送服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供快递、餐饮配送，在承诺的时限内快速完成寄递服务商事主体",
      },
      {
        id: "460",
        industryId: "21474842626",
        industryName: "邮政服务",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供信件、邮票等服务的邮政商事主体及其委托的商事主体",
      },
      {
        id: "461",
        industryId: "21474842627",
        industryName: "鲜花礼品实体店",
        level: "2",
        parentIndustryId: "21474836541",
        description: "售卖鲜花礼品，提供包装、写卡片等服务的实体门店商事主体",
      },
      {
        id: "462",
        industryId: "21474842628",
        industryName: "KTV",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供卡拉OK服务的场所或商事主体",
      },
      {
        id: "463",
        industryId: "21474842629",
        industryName: "户外休闲娱乐场所",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供各种于户外进行的娱乐活动的场所或服务的门店或商事主体",
      },
      {
        id: "464",
        industryId: "21474842630",
        industryName: "室内场景娱乐场所",
        level: "2",
        parentIndustryId: "21474836541",
        description: "提供室内娱乐活动场所或服务的门店或商事主体。例：DIY手工坊",
      },
      {
        id: "465",
        industryId: "21474842631",
        industryName: "网吧",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供上网服务的场所或商事主体",
      },
      {
        id: "466",
        industryId: "21474842632",
        industryName: "影剧院",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指提供话剧与电影放映的场所或商事主体",
      },
      {
        id: "467",
        industryId: "21474842633",
        industryName: "票务代售点",
        level: "2",
        parentIndustryId: "21474836541",
        description: "指为居民提供包括民航、客运、货运、以及演出票务代售的线下实体",
      },
    ],
  },
  {
    id: "468",
    industryId: "21474836542",
    industryName: "食品",
    level: "1",
    parentIndustryId: "0",
    description: "指制造与经销生活中各类即食与原材料食物的商事主体集合",
    children: [
      {
        id: "469",
        industryId: "21474842681",
        industryName: "冰淇淋",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指生产与经销冰淇淋的商事主体",
      },
      {
        id: "470",
        industryId: "21474842682",
        industryName: "营养及健康食品",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指生产与经销不以治疗疾病为目的营养品及健康食品",
      },
      {
        id: "471",
        industryId: "21474842683",
        industryName: "茶叶",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指生产和经销各类茶叶制品（如茶包、包装茶叶）的商事主体",
      },
      {
        id: "472",
        industryId: "21474842684",
        industryName: "粮油调味速食",
        level: "2",
        parentIndustryId: "21474836542",
        description: "生产与经销粮食、油料、调味品、速食（如罐头等）的商事主体",
      },
      {
        id: "473",
        industryId: "21474842685",
        industryName: "乳制品",
        level: "2",
        parentIndustryId: "21474836542",
        description: "生产与经销乳类及加工制成的各种食品的商事主体，如鲜牛奶和奶酪",
      },
      {
        id: "474",
        industryId: "21474842686",
        industryName: "软饮料和冲饮",
        level: "2",
        parentIndustryId: "21474836542",
        description: "生产与经销直接饮用或用水冲调的非酒精饮料的商事主体",
      },
      {
        id: "475",
        industryId: "21474842687",
        industryName: "休闲食品",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指生产与经销在休闲时间和正餐之外食用的各种零食的商事主体",
      },
      {
        id: "476",
        industryId: "21474842689",
        industryName: "宠物饲料制造",
        level: "2",
        parentIndustryId: "21474836542",
        description: "生产与经销供宠物食用的植物类或肉类食品的商事主体。例：皇家",
      },
      {
        id: "477",
        industryId: "21474842690",
        industryName: "冷冻速食品",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指生产与经销冷冻的且经简单加工即可食用的食品的商事主体",
      },
      {
        id: "478",
        industryId: "21474842691",
        industryName: "冷链肉类",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指加工与经销各种肉类（猪肉、牛羊肉）的商事主体",
      },
      {
        id: "479",
        industryId: "21474842692",
        industryName: "水产品",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指经销各类水产品（如海鲜、河鲜等）的商事主体",
      },
      {
        id: "480",
        industryId: "21474842693",
        industryName: "新鲜禽蛋",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指经销各类新鲜禽蛋的商事主体",
      },
      {
        id: "481",
        industryId: "21474842694",
        industryName: "新鲜蔬菜及菌类",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指经销各类新鲜蔬菜、新鲜菌类的商事主体",
      },
      {
        id: "482",
        industryId: "21474842695",
        industryName: "新鲜水果",
        level: "2",
        parentIndustryId: "21474836542",
        description: "指经销各类新鲜水果的商事主体",
      },
    ],
  },
  {
    id: "483",
    industryId: "21474836543",
    industryName: "酒水",
    level: "1",
    parentIndustryId: "0",
    description: "酒是指通过植物发酵等方式产生酒精（乙醇）含量的加工饮品。此处指的主要是制造与经销各种酒类的商事主体集合",
    children: [
      {
        id: "484",
        industryId: "21474842781",
        industryName: "白酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销以粮谷为主原料制成的蒸馏酒的商事主体。例：茅台",
      },
      {
        id: "485",
        industryId: "21474842782",
        industryName: "黄酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销以稻米、黍米、黑米等为原料酿制而成的黄酒的商事主体",
      },
      {
        id: "486",
        industryId: "21474842783",
        industryName: "米酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销以蒸熟的糯米发酵的甜米酒的商事主体，含清酒",
      },
      {
        id: "487",
        industryId: "21474842784",
        industryName: "配制酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销加入可食用辅料，已改变原酒基风格的饮料酒的商事主体",
      },
      {
        id: "488",
        industryId: "21474842785",
        industryName: "啤酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销以小麦芽大麦芽为主原料酿制而成的酒精饮料的商事主体",
      },
      {
        id: "489",
        industryId: "21474842786",
        industryName: "葡萄酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "指生产与经销以葡萄为原料酿造的一种果酒的商事主体",
      },
      {
        id: "490",
        industryId: "21474842787",
        industryName: "其它果酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销由水果本身的糖分发酵而成的酒的商事主体，不含葡萄酒",
      },
      {
        id: "491",
        industryId: "21474842788",
        industryName: "洋酒",
        level: "2",
        parentIndustryId: "21474836543",
        description: "生产与经销进口烈酒的商事主体，除中国白酒、米酒、葡萄酒",
      },
    ],
  },
  {
    id: "492",
    industryId: "21474836544",
    industryName: "互联网内容资讯服务",
    level: "1",
    parentIndustryId: "0",
    description: "指的是互联网上承载和发布各种资讯及各种形态内容的平台，包括新闻、影视、直播、音乐、图文和动漫",
    children: [
      {
        id: "493",
        industryId: "21474842881",
        industryName: "在线新闻及资讯",
        level: "2",
        parentIndustryId: "21474836544",
        description: "以传播新闻和综合资讯的线上平台，如：澎湃、虎嗅、36氪",
      },
      {
        id: "494",
        industryId: "21474842882",
        industryName: "在线直播平台",
        level: "2",
        parentIndustryId: "21474836544",
        description: "指提供通过互联网公开播出即时影像的在线平台",
      },
      {
        id: "495",
        industryId: "21474842883",
        industryName: "音乐流媒体平台",
        level: "2",
        parentIndustryId: "21474836544",
        description: "指提供音乐发布、播放及相关服务的在线平台",
      },
      {
        id: "496",
        industryId: "21474842884",
        industryName: "在线视频平台",
        level: "2",
        parentIndustryId: "21474836544",
        description: "指提供长、中、短视频发布及观看的在线平台",
      },
      {
        id: "497",
        industryId: "21474842885",
        industryName: "阅读与在线FM收听",
        level: "2",
        parentIndustryId: "21474836544",
        description: "指提供网络文学阅读、播客音频收听和发布线上服务的商事主体",
      },
      {
        id: "498",
        industryId: "21474842886",
        industryName: "数字动漫平台",
        level: "2",
        parentIndustryId: "21474836544",
        description: "指专门提供动画和漫画观看、阅读及相关服务的在线平台",
      },
    ],
  },
  {
    id: "499",
    industryId: "21474836545",
    industryName: "数字内容创作",
    level: "1",
    parentIndustryId: "0",
    description: "指进行数字图文、数字音频、视频内容创作和制作的商事主体集合",
    children: [
      {
        id: "500",
        industryId: "21474842981",
        industryName: "录音内容制作",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创作生成录音内容的商事主体，如：光合积木配音工作室",
      },
      {
        id: "501",
        industryId: "21474842982",
        industryName: "其他视频内容",
        level: "2",
        parentIndustryId: "21474836545",
        description: "创作及发布视频内容（除电视、电影、直播）的商事主体",
      },
      {
        id: "502",
        industryId: "21474842983",
        industryName: "其他图文内容",
        level: "2",
        parentIndustryId: "21474836545",
        description: "在媒体上创作上述分类之外的数字图文内容的商事主体",
      },
      {
        id: "503",
        industryId: "21474842984",
        industryName: "数字小说创作",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创作生成小说内容的商事主体",
      },
      {
        id: "504",
        industryId: "21474842985",
        industryName: "数字音乐",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创作生成音乐内容的商事主体",
      },
      {
        id: "505",
        industryId: "21474842986",
        industryName: "网络影视综艺",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指以互联网为首发平台的影视作品及综艺节目制作方",
      },
      {
        id: "506",
        industryId: "21474842987",
        industryName: "直播内容",
        level: "2",
        parentIndustryId: "21474836545",
        description: "在媒体上通过直播方式进行内容创作（非商品销售）的商事主体",
      },
      {
        id: "507",
        industryId: "21474842988",
        industryName: "微信自媒体-财经",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以财经热点、财经资讯为主要内容的商事主体",
      },
      {
        id: "508",
        industryId: "21474842989",
        industryName: "微信自媒体-科教文化",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以科技、教育资讯、文化为主要内容的商事主体",
      },
      {
        id: "509",
        industryId: "21474842990",
        industryName: "微信自媒体-旅游",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以旅游资讯为主要内容的商事主体",
      },
      {
        id: "510",
        industryId: "21474842991",
        industryName: "微信自媒体-美食",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以美食资讯为主要内容的商事主体",
      },
      {
        id: "511",
        industryId: "21474842992",
        industryName: "微信自媒体-汽车房产",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以汽车资讯、房产资讯为主要内容的商事主体",
      },
      {
        id: "512",
        industryId: "21474842993",
        industryName: "微信自媒体-亲子育儿",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以亲子育儿知识传播为主要内容的商事主体",
      },
      {
        id: "513",
        industryId: "21474842994",
        industryName: "微信自媒体-情感美文",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以情感美文为主要内容的商事主体",
      },
      {
        id: "514",
        industryId: "21474842995",
        industryName: "微信自媒体-社会",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以社会热点、新闻资讯类为主要内容的商事主体",
      },
      {
        id: "515",
        industryId: "21474842996",
        industryName: "微信自媒体-生活",
        level: "2",
        parentIndustryId: "21474836545",
        description: "在微信生态内以宠物、家居、手工DIY等为主要内容的商事主体",
      },
      {
        id: "516",
        industryId: "21474842997",
        industryName: "微信自媒体-时尚美容",
        level: "2",
        parentIndustryId: "21474836545",
        description: "在微信生态内以时尚资讯为主要内容的商事主体",
      },
      {
        id: "517",
        industryId: "21474842998",
        industryName: "微信自媒体-运动体育",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在微信生态内以运动、体育资讯为主要内容的商事主体",
      },
      {
        id: "518",
        industryId: "21474842999",
        industryName: "漫画",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创作生成漫画内容的商事主体",
      },
      {
        id: "519",
        industryId: "21474843000",
        industryName: "数字报纸杂志",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创作生成报纸杂志内容的商事主体",
      },
      {
        id: "520",
        industryId: "21474843001",
        industryName: "电影电视",
        level: "2",
        parentIndustryId: "21474836545",
        description: "指在媒体上创生成电影电视（包括动画）内容的商事主体",
      },
    ],
  },
  {
    id: "521",
    industryId: "21474836546",
    industryName: "互联网其他服务",
    level: "1",
    parentIndustryId: "0",
    description: "指提供互联网搜索、交流社区，商业信息共享及提供公益和公共服务的第三方平台",
    children: [
      {
        id: "522",
        industryId: "21474843081",
        industryName: "互联网公共服务平台",
        level: "2",
        parentIndustryId: "21474836546",
        description: "专为公共服务提供者（如政府）提供第三方服务平台的互联网平台",
      },
      {
        id: "523",
        industryId: "21474843082",
        industryName: "互联网公益平台",
        level: "2",
        parentIndustryId: "21474836546",
        description: "指专门为公益组织提供第三方服务平台的互联网平台",
      },
      {
        id: "524",
        industryId: "21474843083",
        industryName: "互联网众包服务平台",
        level: "2",
        parentIndustryId: "21474836546",
        description: "指专门为机构提供工作任务外包服务的互联网平台",
      },
      {
        id: "525",
        industryId: "21474843084",
        industryName: "综合线上社区",
        level: "2",
        parentIndustryId: "21474836546",
        description: "线上交流空间和垂直社区，如：知乎、微博、豆瓣小组",
      },
      {
        id: "526",
        industryId: "21474843085",
        industryName: "互联网搜索",
        level: "2",
        parentIndustryId: "21474836546",
        description: "指提供互联网搜索引擎服务的平台/网站，如：搜搜、必应",
      },
    ],
  },
];
